import { Tooltip, Container, Stack, Grid, Box, FormControlLabel, RadioGroup, FormControl, Radio, TextField, InputAdornment, Divider, Button } from "@mui/material";
import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Alert from '@mui/material/Alert';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import logoblack from '../../components/logoinjupempblack.png'
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import ATLANTIDA from '../participante/LogosBancos/ATLANTIDA.png'
import AZTECA from '../participante/LogosBancos/AZTECA.png'
import BANPAIS from '../participante/LogosBancos/BANPAIS.png'
import FICOHSA from '../participante/LogosBancos/FICOHSA.png'
import LAFISE from '../participante/LogosBancos/LAFISE.png'
import FICENSA from '../participante/LogosBancos/FICENSA.png'
import DAVIVIENDA from '../participante/LogosBancos/DAVIVIENDA.png'
import PROMERICA from '../participante/LogosBancos/PROMERICA.png'
import BANRURAL from '../participante/LogosBancos/BANRURAL.png'
import POPULAR from '../participante/LogosBancos/POPULAR.png'
import BAC from '../participante/LogosBancos/BAC.png'
import CITI from '../participante/LogosBancos/CITI.png'
import BANADESA from '../participante/LogosBancos/BANADESA.png'
import BANHPROVI from '../participante/LogosBancos/BANHPROVI.png'
import BANHCAFE from '../participante/LogosBancos/BANHCAFE.png'
import OCCIDENTE from '../participante/LogosBancos/OCCIDENTE.png'
import TRABAJADORES from '../participante/LogosBancos/TRABAJADORES.png'
import IdentidadEjemplo from './IdentidadEjemplo.jpg'
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Desplegable from "./Components/Desplegable";
import classes from "./ParticipanteClasess.css";
import Aval from "./Components/aval1 copia";
import Aval2 from "./Components/aval2 copia";
import Autocomplete from '@mui/material/Autocomplete';
import dayjs from 'dayjs';
import axios from 'axios';
import 'dayjs/locale/es'; // Importa el archivo de localización para español
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { post, postFiles } from "../../services/http";
import { ContextSession } from "../../services/ContextSession";
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import { useNavigate } from 'react-router-dom';

dayjs.locale('es'); // Establece el idioma local a español

async function getSolicitudInfo(accesos, ip, sid) {
    let json = { SolicitudID: sid };
    let url = ip + "/api/completa/";
    let auto = "Bearer " + accesos;

    let datas = await post(url, json, auto);
    return datas;
};

async function sendDataSolicitud(accesos, ip, json, files, handleClose) {
    try {
        const data = new FormData();
        files.map((file) => {
            data.append(file.nombre, file.file);
        });
        data.append('FilesCount', files.length);
        data.append('data', JSON.stringify(json));
        //console.log(data);

        let url = `${ip}/api/solprestamos/actualizar/`;
        let auto = "Bearer " + accesos;

        let datas = await postFiles(url, data, auto);
        handleClose();
        return datas;
    } catch (error) {
        handleClose();
        console.error(error);
    }
}
function ParticipanteSolicitudes() {
    const navigate = useNavigate();
    const sessi = React.useContext(ContextSession);
    const [civil, setCivil] = useState('');
    const [solicitudIDenviar, setSolicitudIDenviar] = useState('all');
    const [tipoPrestamo, setTipoPrestamo] = useState('all');
    const [TipoVivienda, setTipoVivienda] = useState('all');
    const [TipoViviendaAval1, setTipoViviendaAval1] = useState('all');
    const [TipoViviendaAval2, setTipoViviendaAval2] = useState('all');
    const [tipoCuentaBanco, setTipoCuentaBanco] = useState('all');
    const [banco, setBanco] = useState('');
    //const [bancosSeleccionados, setBancosSeleccionados] = useState(Array(5).fill(''));
    const [departamento, setDepartamento] = useState('');
    //const bancos=["Banco Atlántida S.A.","Banco de Occidente S.A.","Banco de Los Trabajadores","Banco Financiera Centroamericana S.A. (FICENSA)","Banco Hondureño del Café S.A. (BANHCAFE)","Banco del País S.A.","Banco Financiera Comercial Hondureña S.A. (FICOHSA)","Banco Lafise Honduras  S.A.","Banco Davivienda Honduras S.A.","Banco Promérica S.A.","Banco de Desarrollo Rural Honduras S.A.","Banco Azteca de Honduras S.A.","Banco Popular S.A.","Banco de América Central Honduras S.A. – Bac | Honduras","Banco de Honduras (Citi Honduras)"];
    const [salarioMensual, setSalarioMensual] = useState(0);
    const [consolidacionParcial, setConsolidacionParcial] = useState(0);
    const [consolidacionTotal, setConsolidacionTotal] = useState(0);
    const [ihss, setIhss] = useState(0);
    const [isr, setIsr] = useState(0);
    const [prestamoInjupemp, setPrestamoInjupemp] = useState(0);
    const [pensionJubilacion, setPensionJubilacion] = useState(0);
    const [embargos, setEmbargos] = useState(0);
    const [otrosingresos1, setOtrosIngresos1] = useState(0);
    const [otrosingresos2, setOtrosIngresos2] = useState(0);
    const [otrosingresos3, setOtrosIngresos3] = useState(0);
    const [otrosingresos4, setOtrosIngresos4] = useState(0);
    const [otrosingresos5, setOtrosIngresos5] = useState(0);
    const [otrosingresos6, setOtrosIngresos6] = useState(0);
    const [otrosingresos7, setOtrosIngresos7] = useState(0);
    const [totalDeducciones, setTotalDeducciones] = useState(0);
    const [cantidadNeta, setCantidadNeta] = useState(0);
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [fechaVacia, setFechaVacia] = React.useState(null);
    const [selectedDateAval1, setSelectedDateAval1] = React.useState(null);
    const [fechaVaciaAval1, setFechaVaciaAval1] = React.useState(null);
    const [selectedDateAval2, setSelectedDateAval2] = React.useState(null);
    const [fechaVaciaAval2, setFechaVaciaAval2] = React.useState(null);
    const [selectedDateIngreso, setSelectedDateIngreso] = React.useState(null);
    const [fechaVaciaIngreso, setFechaVaciaIngreso] = React.useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedIdentidadSoli, setSelectedIdentidadSoli] = useState(null);
    const [selectedIdentidadAval1, setselectedIdentidadAval1] = useState(null);
    const [selectedIdentidadAval2, setselectedIdentidadAval2] = useState(null);
    const [formulario, setFormulario] = useState({
        //aval1 página 5
        aval1Identidad: '',
        aval1Nombres: '',
        aval1Apellidos: '',
        aval1Nacimiento: null,
        aval1Profesion: '',
        aval1Barrio: '',
        aval1Ave: '',
        aval1Calle: '',
        aval1Casa: '',
        estadocivilAval1: '',
        aval1Ciudad: '',
        aval1Departamento: '',
        aval1ReferenciaDomicilio: '',
        aval1Correo: '',
        aval1Dependencia: '',
        aval1Ramo: '',
        aval1BarrioTrabajo: '',
        aval1AveTrabajo: '',
        aval1CalleTrabajo: '',
        aval1CasaTrabajo: '',
        aval1CiudadTrabajo: '',
        sueldoMensualAval1: '',
        otrosIngresosAval1: '',
        sueldoNetoAval1: '',
        aval1Puesto: '',
        aval1Years: '',
        aval1Meses: '',
        aval1Departamentotrabajo: '',

        //aval2 página 6
        aval2Identidad: '',
        aval2Nombres: '',
        aval2Apellidos: '',
        aval2Nacimiento: null,
        aval2Profesion: '',
        aval2Barrio: '',
        aval2Ave: '',
        aval2Calle: '',
        aval2Casa: '',
        estadocivilAval2: '',
        aval2Ciudad: '',
        aval2Departamento: '',
        aval2ReferenciaDomicilio: '',
        aval2Correo: '',
        aval2Dependencia: '',
        aval2Ramo: '',
        aval2BarrioTrabajo: '',
        aval2AveTrabajo: '',
        aval2CalleTrabajo: '',
        aval2CasaTrabajo: '',
        aval2CiudadTrabajo: '',
        sueldoMensualAval2: '',
        otrosIngresosAval2: '',
        sueldoNetoAval2: '',
        aval2Puesto: '',
        aval2Years: '',
        aval2Meses: '',
        aval2Departamentotrabajo: '',
    });

    //Variables de estado para el formulario

    //Datos de la solicitud
    const [faseSolicitud, setFaseSolicitud] = useState("");
    const [estadoSolicitud, setEstadoSolicitud] = useState(null);
    const [observacion, setObservacion] = useState("");
    const [idEnviar, setIDenviar] = useState("");
    const [montoSolicitado, setMontoSolicitado] = useState("");


    //Datos del solicitante
    const [numeroSolicitud, setNumeroSolicitud] = useState("");
    const [numeroCotizante, setNumeroCotizante] = useState("");
    const [identidadSolicitante, setIdentidadSolicitante] = useState("");
    const [nombresSolicitante, setNombresSolicitante] = useState("");
    const [apellidosSolicitante, setApellidosSolicitante] = useState("");
    const [nacimientoSolicitante, setNacimientoSolicitante] = useState("");
    const [profesionSolicitante, setProfesionSolicitante] = useState("");
    const [tipoViviendaSolicitante, setTipoViviendaSolicitante] = useState("");
    const [direccionSolicitante, setDireccionSolicitante] = useState("");
    const [barrioSolicitante, setBarrioSolicitante] = useState("");
    const [avenidaSolicitante, setAvenidaSolicitante] = useState("");
    const [calleSolicitante, setCalleSolicitante] = useState("");
    const [casaSolicitante, setCasaSolicitante] = useState("");
    const [ciudadSolicitante, setCiudadSolicitante] = useState("");
    const [departamentoSolicitante, setDepartamentoSolicitante] = useState("");
    const [estadoCivilSolicitante, setEstadoCivilSolicitante] = useState("");
    const [referenciaDomicilioSolicitante, setReferenciaDomicilioSolicitante] = useState("");
    const [fijoSolicitante, setFijoSolicitante] = useState("");
    const [movilSolicitante, setMovilSolicitante] = useState("");
    const [correoSolicitante, setCorreoSolicitante] = useState("");

    //Informacion laboral del solicitante
    //const [Solicitante, setSolicitante] = useState("");
    const [dependenciaSolicitante, setDependenciaSolicitante] = useState("");
    const [ramoSolicitante, setRamoSolicitante] = useState("");
    const [telefonoLaboralSolicitante, setTelefonoLaboralSolicitante] = useState("");
    const [barrioLaboralSolicitante, setBarrioLaboralSolicitante] = useState("");
    const [avenidaLaboralSolicitante, setAvenidaLaboralSolicitante] = useState("");
    const [calleLaboralSolicitante, setCalleLaboralSolicitante] = useState("");
    const [casaLaboralSolicitante, setCasaLaboralSolicitante] = useState("");
    const [ciudadLaboralSolicitante, setCiudadLaboralSolicitante] = useState("");
    const [departamentoLaboralSolicitante, setDepartamentoLaboralSolicitante] = useState("");
    const [sueldoMensualSolicitante, setSueldoMensualSolicitante] = useState("");
    const [otrosIngresosSolicitante, setOtrosIngresosSolicitante] = useState("");
    const [sueldoNetoSolicitante, setSueldoNetoSolicitante] = useState("");
    const [puestoSolicitante, setPuestoSolicitante] = useState("");
    const [tiempoLaborarASolicitante, setTiempoLaborarASolicitante] = useState("");
    const [tiempoLaborarMSolicitante, setTiempoLaborarMSolicitante] = useState("");

    //Referencias Personales
    const [referencia1, setReferencia1] = useState("");
    const [parentescoReferencia1, setParentescoReferencia1] = useState("");
    const [direccionReferencia1, setDireccionReferencia1] = useState("");
    const [telefonoReferencia1, setTelefonoReferencia1] = useState("");
    const [referencia2, setReferencia2] = useState("");
    const [parentescoReferencia2, setParentescoReferencia2] = useState("");
    const [direccionReferencia2, setDireccionReferencia2] = useState("");
    const [telefonoReferencia2, setTelefonoReferencia2] = useState("");
    const [idReferencia1, setIdReferencia1] = useState("");
    const [idReferencia2, setIdReferencia2] = useState("");

    //Aval1
    const [idAval1, setIdAval1] = useState("");
    const [identidadAval1, setIdentidadAval1] = useState("");
    const [nombresAval1, setNombresAval1] = useState("");
    const [apellidosAval1, setApellidosAval1] = useState("");
    const [nacimientoAval1, setNacimientoAval1] = useState("");
    const [profesionAval1, setProfesionAval1] = useState("");
    //const [tipoViviendaAval1, setTipoViviendaAval1] = useState("");
    const [direccionAval1, setDireccionAval1] = useState("");
    const [barrioAval1, setBarrioAval1] = useState("");
    const [avenidaAval1, setAvenidaAval1] = useState("");
    const [calleAval1, setCalleAval1] = useState("");
    const [casaAval1, setCasaAval1] = useState("");
    const [ciudadAval1, setCiudadAval1] = useState("");
    const [departamentoAval1, setDepartamentoAval1] = useState("");
    const [estadoCivilAval1, setEstadoCivilAval1] = useState("");
    const [referenciaDomicilioAval1, setReferenciaDomicilioAval1] = useState("");
    const [fijoAval1, setFijoAval1] = useState("");
    const [movilAval1, setMovilAval1] = useState("");
    const [correoAval1, setCorreoAval1] = useState("");
    const [dependenciaAval1, setDependenciaAval1] = useState("");
    const [ramoAval1, setRamoAval1] = useState("");
    const [telefonoLaboralAval1, setTelefonoLaboralAval1] = useState("");
    const [barrioLaboralAval1, setBarrioLaboralAval1] = useState("");
    const [avenidaLaboralAval1, setAvenidaLaboralAval1] = useState("");
    const [calleLaboralAval1, setCalleLaboralAval1] = useState("");
    const [casaLaboralAval1, setCasaLaboralAval1] = useState("");
    const [ciudadLaboralAval1, setCiudadLaboralAval1] = useState("");
    const [departamentoLaboralAval1, setDepartamentoLaboralAval1] = useState("");
    const [sueldoMensualAval1, setSueldoMensualAval1] = useState("");
    const [otrosIngresosAval1, setOtrosIngresosAval1] = useState("");
    const [sueldoNetoAval1, setSueldoNetoAval1] = useState("");
    const [puestoAval1, setPuestoAval1] = useState("");
    const [tiempoLaborarAAval1, setTiempoLaborarAAval1] = useState("");
    const [tiempoLaborarMAval1, setTiempoLaborarMAval1] = useState("");

    //Aval 2
    const [idAval2, setIdAval2] = useState("");
    const [identidadAval2, setIdentidadAval2] = useState("");
    const [nombresAval2, setNombresAval2] = useState("");
    const [apellidosAval2, setApellidosAval2] = useState("");
    const [nacimientoAval2, setNacimientoAval2] = useState("");
    const [profesionAval2, setProfesionAval2] = useState("");
    //const [tipoViviendaAval2, setTipoViviendaAval2] = useState("");
    const [direccionAval2, setDireccionAval2] = useState("");
    const [barrioAval2, setBarrioAval2] = useState("");
    const [avenidaAval2, setAvenidaAval2] = useState("");
    const [calleAval2, setCalleAval2] = useState("");
    const [casaAval2, setCasaAval2] = useState("");
    const [ciudadAval2, setCiudadAval2] = useState("");
    const [departamentoAval2, setDepartamentoAval2] = useState("");
    const [estadoCivilAval2, setEstadoCivilAval2] = useState("");
    const [referenciaDomicilioAval2, setReferenciaDomicilioAval2] = useState("");
    const [fijoAval2, setFijoAval2] = useState("");
    const [movilAval2, setMovilAval2] = useState("");
    const [correoAval2, setCorreoAval2] = useState("");
    const [dependenciaAval2, setDependenciaAval2] = useState("");
    const [ramoAval2, setRamoAval2] = useState("");
    const [telefonoLaboralAval2, setTelefonoLaboralAval2] = useState("");
    const [barrioLaboralAval2, setBarrioLaboralAval2] = useState("");
    const [avenidaLaboralAval2, setAvenidaLaboralAval2] = useState("");
    const [calleLaboralAval2, setCalleLaboralAval2] = useState("");
    const [casaLaboralAval2, setCasaLaboralAval2] = useState("");
    const [ciudadLaboralAval2, setCiudadLaboralAval2] = useState("");
    const [departamentoLaboralAval2, setDepartamentoLaboralAval2] = useState("");
    const [sueldoMensualAval2, setSueldoMensualAval2] = useState("");
    const [otrosIngresosAval2, setOtrosIngresosAval2] = useState("");
    const [sueldoNetoAval2, setSueldoNetoAval2] = useState("");
    const [puestoAval2, setPuestoAval2] = useState("");
    const [tiempoLaborarAAval2, setTiempoLaborarAAval2] = useState("");
    const [tiempoLaborarMAval2, setTiempoLaborarMAval2] = useState("");

    //TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA
    const [tipoCuenta, setTipoCuenta] = useState("");
    const [nombreBanco, setNombreBanco] = useState("");
    const [noCuenta, setNoCuenta] = useState("");

    //Deudas A Consolidar
    const [filas, setFilas] = useState([]);

    //fila 1
    const [idFila1, setIdFila1] = useState("");
    const [institucionNombre1, setInstitucionNombre1] = useState("");
    const [montoLempiras1, setMontoLempiras1] = useState("");
    const [montoDolares1, setMontoDolares1] = useState("");
    const [totalLempiras1, setTotalLempiras1] = useState("");
    const [consolidacionTotal1, setConsolidacionTotal1] = useState("");
    const [consolidacionParcial1, setConsolidacionParcial1] = useState("");

    //fila 2
    const [idFila2, setIdFila2] = useState("");
    const [institucionNombre2, setInstitucionNombre2] = useState("");
    const [montoLempiras2, setMontoLempiras2] = useState("");
    const [montoDolares2, setMontoDolares2] = useState("");
    const [totalLempiras2, setTotalLempiras2] = useState("");
    const [consolidacionTotal2, setConsolidacionTotal2] = useState("");
    const [consolidacionParcial2, setConsolidacionParcial2] = useState("");

    //fila 3
    const [idFila3, setIdFila3] = useState("");
    const [institucionNombre3, setInstitucionNombre3] = useState("");
    const [montoLempiras3, setMontoLempiras3] = useState("");
    const [montoDolares3, setMontoDolares3] = useState("");
    const [totalLempiras3, setTotalLempiras3] = useState("");
    const [consolidacionTotal3, setConsolidacionTotal3] = useState("");
    const [consolidacionParcial3, setConsolidacionParcial3] = useState("");

    //fila 4
    const [idFila4, setIdFila4] = useState("");
    const [institucionNombre4, setInstitucionNombre4] = useState("");
    const [montoLempiras4, setMontoLempiras4] = useState("");
    const [montoDolares4, setMontoDolares4] = useState("");
    const [totalLempiras4, setTotalLempiras4] = useState("");
    const [consolidacionTotal4, setConsolidacionTotal4] = useState("");
    const [consolidacionParcial4, setConsolidacionParcial4] = useState("");

    //fila 5
    const [idFila5, setIdFila5] = useState("");
    const [institucionNombre5, setInstitucionNombre5] = useState("");
    const [montoLempiras5, setMontoLempiras5] = useState("");
    const [montoDolares5, setMontoDolares5] = useState("");
    const [totalLempiras5, setTotalLempiras5] = useState("");
    const [consolidacionTotal5, setConsolidacionTotal5] = useState("");
    const [consolidacionParcial5, setConsolidacionParcial5] = useState("");

    //fila 6
    const [idFila6, setIdFila6] = useState("");
    const [totalMontoLempiras1, setTotalMontoLempiras1] = useState("");
    const [totalMontoDolares1, setTotalMontoDolares1] = useState("");
    const [totalTotalLempiras1, setTotalTotalLempiras1] = useState("");
    const [totalConsolidacionTotal1, setTotalConsolidacionTotal1] = useState("");
    const [totalConsolidacionParcial1, setTotalConsolidacionParcial1] = useState("");

    //fila 7
    const [idFila7, setIdFila7] = useState("");
    const [totalMontoLempiras2, setTotalMontoLempiras2] = useState("");
    const [totalMontoDolares2, setTotalMontoDolares2] = useState("");
    const [totalTotalLempiras2, setTotalTotalLempiras2] = useState("");
    const [totalConsolidacionTotal2, setTotalConsolidacionTotal2] = useState("");
    const [totalConsolidacionParcial2, setTotalConsolidacionParcial2] = useState("");

    const [EstadoParticipante, setEstadoParticipante] = useState("");

    function CustomDatePickerNacimiento(props) {
        const today = dayjs();
        const [invalidFormat, setInvalidFormat] = React.useState(false);
        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDate(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChange = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormat(true);
            } else {
                setInvalidFormat(false);
                setSelectedDate(date);
                setFechaVacia(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDate}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChange}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechaVacia ? 'Seleccione la fecha de nacimiento' : invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVacia || invalidFormat,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>

        );
    }

    function CustomDatePickerIngreso(props) {
        const today = dayjs();
        const [invalidFormatIngreso, setInvalidFormatIngreso] = React.useState(false);

        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setSelectedDateIngreso(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChangeIngreso = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormatIngreso(true);
            } else {
                setInvalidFormatIngreso(false);
                setSelectedDateIngreso(date);
                setFechaVaciaIngreso(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selectedDateIngreso}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChangeIngreso}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechaVaciaIngreso ? 'Seleccione la fecha de ingreso' : invalidFormatIngreso ? "Formato de fecha incorrecto" : (selectedDateIngreso && dayjs(selectedDateIngreso).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechaVaciaIngreso || invalidFormatIngreso,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>
        );
    }

    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ramo, setRamo] = useState('');
    const [dependencias, setDependencias] = useState([]);

    useEffect(() => {
        //console.log("SESSION DATA", sessi.sessionData.id);
        const container = document.getElementById('my-container');
        container.style.zoom = "80%";
        const fetchDependencias = async () => {
            try {
                setLoading(true);
                const response = await axios.post(`${sessi.ip}/api/dependencias/`, {});
                //console.log('API response:', response.data); // Log de la respuesta de la API
                const instituciones = response.data.Instituciones;
                setDependencias(instituciones);
                const opciones = instituciones.map((inst, index) => `${index + 1}. ${inst.DSCEST.trim()}`);
                //console.log('Opciones:', opciones); // Log de las opciones procesadas
                setOptions(opciones);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchDependencias();
    }, []);

    const handleDependenciaChange = (event, value) => {
        const selectedDependencia = dependencias.find(inst => `${dependencias.indexOf(inst) + 1}. ${inst.DSCEST.trim()}` === value);
        if (selectedDependencia) {
            setRamo(selectedDependencia.RAMO);
        } else {
            setRamo('');
        }
    };


    const handleBlurSalario = () => {
        // Calcula el total de deducciones
        const totalDeducciones = ihss + isr + prestamoInjupemp + pensionJubilacion + embargos + otrosingresos1 + otrosingresos2 + otrosingresos3 + otrosingresos4 + otrosingresos5 + otrosingresos6 + otrosingresos7;
        setTotalDeducciones(totalDeducciones);

        // Calcula la cantidad neta que percibe al mes
        const cantidadNeta = salarioMensual - totalDeducciones;
        setCantidadNeta(cantidadNeta);
    };

    function handleTipoPrestamo(event) {
        setTipoPrestamo(event.target.value);
    }

    function handleTipoVivienda(event) {
        setTipoVivienda(event.target.value);
    }

    function handleTipoViviendaAval1(event) {
        setTipoViviendaAval1(event.target.value);
    }

    function handleTipoViviendaAval2(event) {
        setTipoViviendaAval2(event.target.value);
    }

    function handleTipoCuentaBanco(event) {
        setTipoCuentaBanco(event.target.value);
    }

    // Funciones para manejar cambios en los campos y actualizar el estado
    const handleChange = (event) => {
        const { id, value } = event.target;
        setFormulario(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    /*const handleBanco = (index, event) => {
        const newBancosSeleccionados = [...bancosSeleccionados];
        newBancosSeleccionados[index] = event.target.value;
        setBancosSeleccionados(newBancosSeleccionados);
    };*/

    /*function handleBancoCuenta(event){
        setBanco(event.target.value);
    }

    function handleDepartamento(event){
        setDepartamento(event.target.value);
    }
    const handleChange = (event) => {
        setCivil(event.target.value);
    };*/

    const flatProps = {
        options: listadepartamentos.map((option) => option.title),
    };

    const renderOption = (props, option) => (
        <Box component="li" {...props} style={{ display: 'flex', alignItems: 'center' }}>
            <img
                alt={option.title}
                src={option.title === 'Banco Azteca de Honduras S.A.' ? AZTECA :
                    option.title === 'Banco Atlántida S.A.' ? ATLANTIDA :
                        option.title === 'Banco de Occidente S.A.' ? OCCIDENTE :
                            option.title === 'Banco de Los Trabajadores' ? TRABAJADORES :
                                option.title === 'Banco Financiera Centroamericana S.A. (FICENSA)' ? FICENSA :
                                    option.title === 'Banco Hondureño del Café S.A. (BANHCAFE)' ? BANHCAFE :
                                        option.title === 'Banco del País S.A. (BANPAIS)' ? BANPAIS :
                                            option.title === 'Banco Financiera Comercial Hondureña S.A. (FICOHSA)' ? FICOHSA :
                                                option.title === 'Banco Davivienda Honduras S.A.' ? DAVIVIENDA :
                                                    option.title === 'Banco Promérica S.A.' ? PROMERICA :
                                                        option.title === 'Banco de Desarrollo Rural Honduras S.A.' ? BANRURAL :
                                                            option.title === 'Banco Popular S.A.' ? POPULAR :
                                                                option.title === 'Banco de América Central Honduras S.A. (BAC) | Honduras' ? BAC :
                                                                    option.title === 'Banco Lafise Honduras  S.A.' ? LAFISE :
                                                                        option.title === 'Banco de Honduras (Citi Honduras)' ? CITI :
                                                                            option.title === 'Banco Nacional de Desarrollo Agrícola (BANADESA)' ? BANADESA :
                                                                                option.title === 'Banco Hondureño para la Producción y la Vivienda (BANHPROVI)' ? BANHPROVI :
                                                                                    null} // Suponiendo que los logos están nombrados según el código del banco
                style={{ width: '20%', height: '20%', objectFit: 'contain', marginRight: '10px' }}
            />
            <span>{option.title}</span>
        </Box>
    );

    const isOptionEqualToValue = (option, value) => option.title === value.title;

    const defaultProps = {
        options: listadepartamentos,
        getOptionLabel: (option) => option.title,
        isOptionEqualToValue: isOptionEqualToValue,
    };

    const defaultPropsBancos = {
        options: listabancos,
        getOptionLabel: (option) => option.title,
        renderOption: renderOption,
        isOptionEqualToValue: isOptionEqualToValue,
    };

    const defaultPropsCivil = {
        options: listacivil,
        getOptionLabel: (option) => option.title,
        isOptionEqualToValue: isOptionEqualToValue,
    };

    const flatPropsCivil = {
        options: listacivil.map((option) => option.title),
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#6BC5D0',
            color: 'white',
            fontSize: 16,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    const validarSoloNumeros = (event) => {
        // Solo permitir números
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    };

    const validarSoloNumerosComa = (event) => {
        // Solo permitir números y el punto decimal
        event.target.value = event.target.value.replace(/[^0-9.]/g, '');

        // Asegurarse de que solo haya un punto decimal
        if (event.target.value.split('.').length > 2) {
            event.target.value = event.target.value.replace(/\.+$/, "");
        }

        // Formatear con comas
        const parts = event.target.value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        event.target.value = parts.join('.');
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras, espacios y letras con acentos
        event.target.value = event.target.value.replace(/[^A-Za-zÁÉÍÓÚÜáéíóúü\s]/g, '');

        // Convertir a mayúsculas
        event.target.value = event.target.value.toUpperCase();
    };

    /*---------------------Validación Longitudes Y Campos Vacíos* ---------------*/

    const [errors, setErrors] = useState({});

    const handleBlur = (event) => {
        const fieldName = event.target.id;
        const fieldValue = event.target.value;
        let errorMessage = '';

        // Validación para la identidad
        if (fieldName === 'NumeroIdentidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        // Validación para la identidad del aval 1
        if (fieldName === 'aval1Identidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        if (fieldName === 'aval2Identidad') {
            if (fieldValue.length !== 13) {
                errorMessage = 'La identidad debe ser de 13 dígitos';
            }
        }

        // Validación para los números de teléfono del aval 1
        if (fieldName === 'aval1Movil' || fieldName === 'aval1Fijo' || fieldName === 'aval1TelefonoTrabajo') {
            if (fieldValue.length !== 8) {
                errorMessage = 'El teléfono debe ser de 8 dígitos';
            }
        }

        // Validación para los números de teléfono del aval 2
        if (fieldName === 'aval2Movil' || fieldName === 'aval2Fijo' || fieldName === 'aval2TelefonoTrabajo') {
            if (fieldValue.length !== 8) {
                errorMessage = 'El teléfono debe ser de 8 dígitos';
            }
        }

        // Validación para los números de teléfono
        if (fieldName === 'TelefonoMovil' || fieldName === 'TelefonoFijo' ||
            fieldName === 'laboralTelefono') {
            if (fieldValue.length !== 8) {
                errorMessage = 'El teléfono debe ser de 8 dígitos';
            }
        }

        // Validación para otros campos
        const fieldNamesToMessages = {
            Nombres: 'Ingrese los nombres del solicitante',
            Apellidos: 'Ingrese los apellidos del solicitante',
            Profesion: 'Ingrese la profesión del solicitante',
            BarrioCol: 'Ingrese el barrio del solicitante',
            Ave: 'Ingrese la avenida del solicitante',
            Calle: 'Ingrese la calle del solicitante',
            CasaNo: 'Ingrese el número de casa del solicitante',
            Ciudad: 'Ingrese la ciudad del solicitante',
            Departamento: 'Ingrese el departamento del solicitante',
            Direccion: 'Ingrese una referencia del domicilio del solicitante',
            CorreoElectronico: 'Ingrese el correo del solicitante',
            DependenciaTrabajo: 'Ingrese la dependencia laboral del solicitante',
            Ramo: 'Ingrese el ramo laboral del solicitante',
            laboralBarrio: 'Ingrese el barrio laboral del solicitante',
            laboralAve: 'Ingrese la avenida laboral del solicitante',
            laboralCalle: 'Ingrese la calle laboral del solicitante',
            laboralCasa: 'Ingrese el número de casa laboral del solicitante',
            sueldoMensualsoli: 'Ingrese el sueldo mensual del solicitante',
            laboralCiudad: 'Ingrese la ciudad laboral del solicitante',
            laboralDepartamento: 'Ingrese el departamento laboral del solicitante',
            otrosIngresossoli: 'Ingrese otros ingresos del solicitante',
            sueldoNetosoli: 'Ingrese el sueldo neto del solicitante',
            laboralPuesto: 'Ingrese el puesto laboral del solicitante',
            laboralYears: 'Ingrese los años de experiencia laboral del solicitante',
            laboralMeses: 'Ingrese los meses de experiencia laboral del solicitante',
            rrhhSalarioMensual: 'Ingrese el salario nominal mensual del solicitante',
            ihss: 'Ingrese el IHSS',
            pensionjubilacion: 'Ingrese la pensión o jubilación',
            nocuenta: 'Ingrese el número de cuenta',
            EstadoCivil: 'Ingrese el estado civil del solicitante',
            solicitanteBancoCuenta: 'Ingrese el banco de la cuenta del solicitante',
            referencia1Nombres: 'Ingrese el nombre de la referencia personal 1',
            referencia1Parentesco: 'Ingrese el parentesco de la referencia personal 1',
            referencia1Direccion: 'Ingrese la dirección de la referencia personal 1',
            referencia1Telefono: 'Ingrese el teléfono de la referencia personal 1',
            referencia2Nombres: 'Ingrese el nombre de la referencia personal 2',
            referencia2Parentesco: 'Ingrese el parentesco de la referencia personal 2',
            referencia2Direccion: 'Ingrese la dirección de la referencia personal 2',
            referencia2Telefono: 'Ingrese el teléfono de la referencia personal 2',
            solicitanteBancoCuentaConsolidar1: 'Ingrese el nombre del banco',
            lempirasconsolidar1: 'Ingrese valor lempiras',
            dolaresconsolidar1: 'Ingrese valor dólares',
            consolidacionparcial1: 'Ingrese valor parcial',

            //AVAL 1
            aval1Nombres: 'Ingrese los nombres del aval 1',
            aval1Apellidos: 'Ingrese los apellidos del aval 1',
            aval1Profesion: 'Ingrese la profesión del aval 1',
            aval1Barrio: 'Ingrese el barrio del aval 1',
            aval1Ave: 'Ingrese la avenida del aval 1',
            aval1Calle: 'Ingrese la calle del aval 1',
            aval1Casa: 'Ingrese el número de casa del aval 1',
            aval1Ciudad: 'Ingrese la ciudad del aval 1',
            aval1Departamento: 'Ingrese el departamento del aval 1',
            aval1ReferenciaDomicilio: 'Ingrese una referencia del domicilio del aval 1',
            aval1Correo: 'Ingrese el correo del aval 1',
            aval1Dependencia: 'Ingrese la dependencia laboral del aval 1',
            aval1Ramo: 'Ingrese el ramo laboral del aval 1',
            aval1BarrioTrabajo: 'Ingrese el barrio laboral del aval 1',
            aval1AveTrabajo: 'Ingrese la avenida laboral del aval 1',
            aval1CalleTrabajo: 'Ingrese la calle laboral del aval 1',
            aval1CasaTrabajo: 'Ingrese el número de casa laboral del aval 1',
            aval1CiudadTrabajo: 'Ingrese la ciudad laboral del aval 1',
            sueldoMensualAval1: 'Ingrese el sueldo mensual del aval 1',
            otrosIngresosAval1: 'Ingrese otros ingresos del aval 1',
            sueldoNetoAval1: 'Ingrese el sueldo neto del aval 1',
            estadocivilAval1: 'Ingrese el estado civil del Aval 1',
            aval1Puesto: 'Ingrese el puesto laboral del aval 1',
            aval1Years: 'Ingrese los años de experiencia laboral del aval 1',
            aval1Meses: 'Ingrese los meses de experiencia laboral del aval 1',
            aval1Departamentotrabajo: 'Ingrese el departamento laboral del aval 1',

            //Aval 2
            aval2Nombres: 'Ingrese los nombres del aval 2',
            aval2Apellidos: 'Ingrese los apellidos del aval 2',
            aval2Profesion: 'Ingrese la profesión del aval 2',
            aval2Barrio: 'Ingrese el barrio del aval 2',
            aval2Ave: 'Ingrese la avenida del aval 2',
            aval2Calle: 'Ingrese la calle del aval 2',
            aval2Casa: 'Ingrese el número de casa del aval 2',
            aval2Ciudad: 'Ingrese la ciudad del aval 2',
            aval2Departamento: 'Ingrese el departamento del aval 2',
            aval2ReferenciaDomicilio: 'Ingrese una referencia del domicilio del aval 2',
            aval2Correo: 'Ingrese el correo del aval 2',
            aval2Dependencia: 'Ingrese la dependencia laboral del aval 2',
            aval2Ramo: 'Ingrese el ramo laboral del aval 2',
            aval2BarrioTrabajo: 'Ingrese el barrio laboral del aval 2',
            aval2AveTrabajo: 'Ingrese la avenida laboral del aval 2',
            aval2CalleTrabajo: 'Ingrese la calle laboral del aval 2',
            aval2CasaTrabajo: 'Ingrese el número de casa laboral del aval 2',
            aval2CiudadTrabajo: 'Ingrese la ciudad laboral del aval 2',
            sueldoMensualAval2: 'Ingrese el sueldo mensual del aval 2',
            otrosIngresosAval2: 'Ingrese otros ingresos del aval 2',
            sueldoNetoAval2: 'Ingrese el sueldo neto del aval 2',
            aval2Puesto: 'Ingrese el puesto laboral del aval 2',
            aval2Years: 'Ingrese los años de experiencia laboral del aval 2',
            aval2Meses: 'Ingrese los meses de experiencia laboral del aval 2',
            estadocivilAval2: 'Ingrese el estado civil del Aval 2',
            aval2Departamentotrabajo: 'Ingrese el departamento laboral del aval 2'
        };

        if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
            if (fieldValue.length < 1) {
                errorMessage = fieldNamesToMessages[fieldName];
            }
        }

        setErrors({
            ...errors,
            [fieldName]: errorMessage
        });
    };

    /*---------------------FINAL Validación Longitudes Y Campos Vacíos* ---------------*/

    const validateErrors = (props) => {

        // Obtener todos los elementos de entrada dentro del formulario
        const inputFields = document.querySelectorAll('input');
        const files = [];
        // Objeto para almacenar los valores de los campos de entrada
        const fieldValues = {};

        // Iterar sobre los elementos de entrada y obtener sus valores
        inputFields.forEach(input => {
            fieldValues[input.id] = input.value;
        });

        // Objeto para almacenar los mensajes de error
        let errorMessages = {};

        if (tipoPrestamo === 'all') {
            errorMessages[0] = '-Seleccione el tipo de préstamo a solicitar en el inicio del formulario.'
        } else {
            fieldValues["tipoDePrestamo"] = tipoPrestamo;

            if (!selectedFile) {
                errorMessages['selectedFile'] = '-Adjunte vouchers de pago en formato PDF';
            }


            // Ejecutar la lógica de validación para cada campo
            Object.entries(fieldValues).forEach(([fieldName, fieldValue]) => {
                let errorMessage = '';

                if (!selectedDate) {
                    errorMessages['FechaNacimiento'] = '-Seleccione la fecha de nacimiento del solicitante';
                    setFechaVacia(true);
                }

                if (!selectedIdentidadSoli) {
                    errorMessages['selectedIdentidadSoli'] = '-Adjunte identidad del solicitante en formato PDF';
                }

                if (TipoVivienda === 'all') {
                    errorMessages['TipoVivienda'] = '-Seleccione el tipo de vivienda del solicitante.';
                } else {
                    fieldValues["tipoDeVivienda"] = TipoVivienda;
                }

                if (tipoCuentaBanco === 'all') {
                    errorMessages['tipoCuentaBanco'] = '-Seleccione el tipo de cuenta de banco del solicitante.';
                } else {
                    fieldValues["tipoCuentaBanco"] = tipoCuentaBanco;
                }

                /*if (!selectedDateIngreso) {
                    errorMessages['rrhhingreso'] = '-Seleccione la fecha de ingreso';
                    setFechaVaciaIngreso(true);
                }*/

                if (fieldName === 'NumeroIdentidad') {
                    if (fieldValue.length !== 13) {
                        errorMessage = '-La identidad del solicitante debe ser de 13 dígitos';
                    }
                }

                if (fieldName === 'aval1Identidad') {
                    if (fieldValue.length !== 13) {
                        errorMessage = '-La identidad del Aval 1 debe ser de 13 dígitos';
                    }
                }

                if (fieldName === 'aval2Identidad') {
                    if (fieldValue.length !== 13) {
                        errorMessage = '-La identidad del Aval 2 debe ser de 13 dígitos';
                    }
                }

                if (tipoPrestamo === 'Con Aval' || tipoPrestamo === 'Consolidacion de Deuda') {
                    if (!selectedDateAval1) {
                        errorMessages['aval1nacimiento'] = '-Seleccione la fecha de nacimiento del aval 1';
                        setFechaVaciaAval1(true);
                    }

                    if (!selectedDateAval2) {
                        errorMessages['aval2nacimiento'] = '-Seleccione la fecha de nacimiento del aval 2';
                        setFechaVaciaAval2(true);
                    }

                    if (!selectedIdentidadAval1) {
                        errorMessages['selectedIdentidadAval1'] = '-Adjunte identidad del aval 1 en formato PDF';
                    }

                    if (!selectedIdentidadAval2) {
                        errorMessages['selectedIdentidadAval2'] = '-Adjunte identidad del aval 2 en formato PDF';
                    }

                    if (TipoViviendaAval1 === 'all') {
                        errorMessages['TipoViviendaAval1'] = '-Seleccione el tipo de vivienda del aval 1.';
                    } else {
                        fieldValues["TipoViviendaAval1"] = TipoViviendaAval1;
                    }

                    if (TipoViviendaAval2 === 'all') {
                        errorMessages['TipoViviendaAval2'] = '-Seleccione el tipo de vivienda del aval 2.';
                    } else {
                        fieldValues["TipoViviendaAval2"] = TipoViviendaAval2;
                    }
                }

                // Validación para los números de teléfono
                if (fieldName === 'TelefonoMovil') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono móvil del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'TelefonoFijo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono fijo del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'laboralTelefono') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'laboralTelefono') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del solicitante debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval1Movil') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono móvil del aval 1 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval1Fijo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono fijo del aval 1 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval1TelefonoTrabajo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del aval 1 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval2Movil') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono móvil del aval 2 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval2Fijo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono fijo del aval 2 debe ser de 8 dígitos';
                    }
                }

                if (fieldName === 'aval2TelefonoTrabajo') {
                    if (fieldValue.length !== 8) {
                        errorMessage = '-El teléfono laboral del aval 2 debe ser de 8 dígitos';
                    }
                }



                //Validación detalle de salario y deducciones del solicitante
                if (fieldName === 'cantidadneta') {
                    if (salarioMensual < totalDeducciones) {
                        errorMessage = `-El total de deducciones "L.${totalDeducciones}" es mayor que el salario nominal mensual "L.${salarioMensual}"`;
                    }
                }

                if (fieldName === 'consolidacionparcial1') {
                    if (consolidacionParcial > consolidacionTotal) {
                        errorMessage = `-La consolidación parcial "L.${consolidacionParcial}" es mayor que la consolidación total "L.${consolidacionTotal}"`;
                    }
                }

                // Validación para otros campos
                const fieldNamesToMessages = {
                    //---------------SOLICITANTE----------------------------
                    Nombres: '-Ingrese los nombres del solicitante',
                    Apellidos: '-Ingrese los apellidos del solicitante',
                    //FechaNacimiento: '-Ingrese fecha de nacimiento del solicitante',
                    Profesion: '-Ingrese la profesión del solicitante',
                    BarrioCol: '-Ingrese el barrio del solicitante',
                    Ave: '-Ingrese la avenida del solicitante',
                    Calle: '-Ingrese la calle del solicitante',
                    CasaNo: '-Ingrese el número de casa del solicitante',
                    Ciudad: '-Ingrese la ciudad del solicitante',
                    Departamento: '-Ingrese el departamento del solicitante',
                    Direccion: '-Ingrese una referencia del domicilio del solicitante',
                    CorreoElectronico: '-Ingrese el correo del solicitante',
                    DependenciaTrabajo: '-Ingrese la dependencia laboral del solicitante',
                    Ramo: '-Ingrese el ramo laboral del solicitante',
                    laboralBarrio: '-Ingrese el barrio laboral del solicitante',
                    laboralAve: '-Ingrese la avenida laboral del solicitante',
                    laboralCalle: '-Ingrese la calle laboral del solicitante',
                    laboralCasa: '-Ingrese el número de casa laboral del solicitante',
                    laboralCiudad: '-Ingrese la ciudad laboral del solicitante',
                    laboralDepartamento: '-Ingrese el departamento laboral del solicitante',
                    sueldoMensualsoli: '-Ingrese el sueldo mensual del solicitante',
                    otrosIngresossoli: '-Ingrese otros ingresos del solicitante',
                    sueldoNetosoli: '-Ingrese el sueldo neto del solicitante',
                    laboralPuesto: '-Ingrese el puesto laboral del solicitante',
                    laboralYears: '-Ingrese los años de experiencia laboral del solicitante',
                    laboralMeses: '-Ingrese los meses de experiencia laboral del solicitante',
                    rrhhSalarioMensual: '-Ingrese el salario nominal mensual del solicitante',
                    //ihss: '-Ingrese el IHSS',
                    //pensionjubilacion: '-Ingrese la pensión o jubilación',
                    nocuenta: '-Ingrese el número de cuenta bancaria del solicitante',
                    EstadoCivil: '-Ingrese el estado civil del solicitante',
                    solicitanteBancoCuenta: '-Ingrese el banco de la cuenta del solicitante',
                    referencia1Nombres: '-Ingrese el nombre de la referencia personal 1',
                    referencia1Parentesco: '-Ingrese el parentesco de la referencia personal 1',
                    referencia1Direccion: '-Ingrese la dirección de la referencia personal 1',
                    referencia1Telefono: '-Ingrese el teléfono de la referencia personal 1',
                    referencia2Nombres: '-Ingrese el nombre de la referencia personal 2',
                    referencia2Parentesco: '-Ingrese el parentesco de la referencia personal 2',
                    referencia2Direccion: '-Ingrese la dirección de la referencia personal 2',
                    referencia2Telefono: '-Ingrese el teléfono de la referencia personal 2',

                    //-------------AVAL 1-----------------------------
                    aval1Nombres: '-Ingrese los nombres del aval 1',
                    aval1Apellidos: '-Ingrese los apellidos del aval 1',
                    aval1Profesion: '-Ingrese la profesión del aval 1',
                    aval1Barrio: '-Ingrese el barrio del aval 1',
                    aval1Ave: '-Ingrese la avenida del aval 1',
                    aval1Calle: '-Ingrese la calle del aval 1',
                    aval1Casa: '-Ingrese el número de casa del aval 1',
                    aval1Ciudad: '-Ingrese la ciudad del aval 1',
                    aval1Departamento: '-Ingrese el departamento del aval 1',
                    aval1ReferenciaDomicilio: '-Ingrese una referencia del domicilio del aval 1',
                    aval1Correo: '-Ingrese el correo del aval 1',
                    aval1Dependencia: '-Ingrese la dependencia laboral del aval 1',
                    aval1Ramo: '-Ingrese el ramo laboral del aval 1',
                    aval1BarrioTrabajo: '-Ingrese el barrio laboral del aval 1',
                    aval1AveTrabajo: '-Ingrese la avenida laboral del aval 1',
                    aval1CalleTrabajo: '-Ingrese la calle laboral del aval 1',
                    aval1CasaTrabajo: '-Ingrese el número de casa laboral del aval 1',
                    aval1CiudadTrabajo: '-Ingrese la ciudad laboral del aval 1',
                    sueldoMensualAval1: '-Ingrese el sueldo mensual del aval 1',
                    otrosIngresosAval1: '-Ingrese otros ingresos del aval 1',
                    sueldoNetoAval1: '-Ingrese el sueldo neto del aval 1',
                    aval1Puesto: '-Ingrese el puesto laboral del aval 1',
                    aval1Years: '-Ingrese los años de experiencia laboral del aval 1',
                    aval1Meses: '-Ingrese los meses de experiencia laboral del aval 1',
                    aval1Departamentotrabajo: '-Ingrese el departamento laboral del aval 1',
                    estadocivilAval1: '-Ingrese el estado civil del Aval 1',

                    //---------------AVAL 2---------------------------
                    aval2Nombres: '-Ingrese los nombres del aval 2',
                    aval2Apellidos: '-Ingrese los apellidos del aval 2',
                    aval2Profesion: '-Ingrese la profesión del aval 2',
                    aval2Barrio: '-Ingrese el barrio del aval 2',
                    aval2Ave: '-Ingrese la avenida del aval 2',
                    aval2Calle: '-Ingrese la calle del aval 2',
                    aval2Casa: '-Ingrese el número de casa del aval 2',
                    aval2Ciudad: '-Ingrese la ciudad del aval 2',
                    aval2Departamento: '-Ingrese el departamento del aval 2',
                    aval2ReferenciaDomicilio: '-Ingrese una referencia del domicilio del aval 2',
                    aval2Correo: '-Ingrese el correo del aval 2',
                    aval2Dependencia: '-Ingrese la dependencia laboral del aval 2',
                    aval2Ramo: '-Ingrese el ramo laboral del aval 2',
                    aval2BarrioTrabajo: '-Ingrese el barrio laboral del aval 2',
                    aval2AveTrabajo: '-Ingrese la avenida laboral del aval 2',
                    aval2CalleTrabajo: '-Ingrese la calle laboral del aval 2',
                    aval2CasaTrabajo: '-Ingrese el número de casa laboral del aval 2',
                    aval2CiudadTrabajo: '-Ingrese la ciudad laboral del aval 2',
                    sueldoMensualAval2: '-Ingrese el sueldo mensual del aval 2',
                    otrosIngresosAval2: '-Ingrese otros ingresos del aval 2',
                    sueldoNetoAval2: '-Ingrese el sueldo neto del aval 2',
                    aval2Puesto: '-Ingrese el puesto laboral del aval 2',
                    aval2Years: '-Ingrese los años de experiencia laboral del aval 2',
                    aval2Meses: '-Ingrese los meses de experiencia laboral del aval 2',
                    aval2Departamentotrabajo: '-Ingrese el departamento laboral del aval 2',
                    estadocivilAval2: '-Ingrese el estado civil del Aval 2',

                    //---------DEUDAS A CONSOLIDAR----------
                    solicitanteBancoCuentaConsolidar1: '-Ingrese el nombre del banco',
                    lempirasconsolidar1: '-Ingrese valor lempiras',
                    dolaresconsolidar1: '-Ingrese valor dólares',
                    consolidacionparcial1: '-Ingrese valor parcial'
                };

                if (fieldNamesToMessages.hasOwnProperty(fieldName)) {
                    if (fieldValue.length < 1) {
                        errorMessage = fieldNamesToMessages[fieldName];
                    }
                }

                errorMessages[fieldName] = errorMessage;
            });
        }

        // Actualizar el estado de los errores
        setErrors(errorMessages);

        // Verificar si hay errores después de ejecutar la validación
        const hasErrors = Object.values(errorMessages).some(error => error !== '');
        if (hasErrors) {
            setOpenDialogErrores(true);
        } else {
            // Generar JSON con los datos del formulario
            files.push({ nombre: "SolDni", file: selectedIdentidadSoli });
            files.push({ nombre: "Aval1dni", file: selectedIdentidadAval1 });
            files.push({ nombre: "Aval2dni", file: selectedIdentidadAval2 });
            files.push({ nombre: "voucher", file: selectedFile });
            const jsonOutput = {
                "solicitud_prestamo": {
                    "SolicitudID": solicitudIDenviar,
                    "NumeroSolicitud": numeroSolicitud,
                    "NumeroCotizante": document.getElementById("SolicitanteID").value,
                    "TipoPrestamo": tipoPrestamo,
                    "FechaSolicitud": new Date().toISOString().split('T')[0],
                    "UsuarioID": sessi.sessionData.id,
                    "Estado": "Nuevo",
                    "MontoSolicitado": document.getElementById("montosolicitado").value,
                    "observacion": null,
                    "aprobado": 4,
                    "asignado": null,
                    "EstadoParticipante": EstadoParticipante,
                },
                "datos_solicitante": {
                    "NumeroIdentidad": document.getElementById("NumeroIdentidad").value,
                    "Nombres": document.getElementById("Nombres").value,
                    "Apellidos": document.getElementById("Apellidos").value,
                    "FechaNacimiento": selectedDate,
                    "Profesion": document.getElementById("Profesion").value,
                    "TipoVivienda": TipoVivienda,
                    "Direccion": "Av. Principal",
                    "BarrioCol": document.getElementById("BarrioCol").value,
                    "Ave": document.getElementById("Ave").value,
                    "Calle": document.getElementById("Calle").value,
                    "CasaNo": document.getElementById("CasaNo").value,
                    "Ciudad": document.getElementById("Ciudad").value,
                    "Departamento": document.getElementById("Departamento").value,
                    "EstadoCivil": document.getElementById("EstadoCivil").value,
                    "ReferenciaDomicilio": document.getElementById("Direccion").value,
                    "TelefonoFijo": document.getElementById("TelefonoFijo").value,
                    "TelefonoMovil": document.getElementById("TelefonoMovil").value,
                    "CorreoElectronico": document.getElementById("CorreoElectronico").value,
                    "ArchivoPDF": "Identidad.pdf"
                },
                "referencias_personales": [
                    {
                        "ReferenciaID": idReferencia1,
                        "Nombre": document.getElementById("referencia1Nombres").value,
                        "Parentesco": document.getElementById("referencia1Parentesco").value,
                        "Direccion": document.getElementById("referencia1Direccion").value,
                        "Telefono": document.getElementById("referencia1Telefono").value
                    },
                    {
                        "ReferenciaID": idReferencia2,
                        "Nombre": document.getElementById("referencia2Nombres").value,
                        "Parentesco": document.getElementById("referencia2Parentesco").value,
                        "Direccion": document.getElementById("referencia2Direccion").value,
                        "Telefono": document.getElementById("referencia2Telefono").value
                    }
                ],
                "transferencia_pago": {
                    "TipoCuenta": tipoCuentaBanco,
                    "Banco": document.getElementById("solicitanteBancoCuenta").value,
                    "NoCuenta": document.getElementById("nocuenta").value
                },
                "deudas_consolidar": [
                    {
                        "DeudaID": idFila1,
                        "InstitucionFinanciera": document.getElementById("solicitanteBancoCuentaConsolidar1").value || "0",
                        "MontoLempiras": document.getElementById("lempirasconsolidar1").value || "0",
                        "MontoDolares": document.getElementById("dolaresconsolidar1").value || "0",
                        "TotalLempiras": document.getElementById("total-lempiras-consolidar-1").value || "0",
                        "ConsolidacionTotal": document.getElementById("consolidaciontotal1").value || "0",
                        "ConsolidacionParcial": document.getElementById("consolidacionparcial1").value || "0"
                    },
                    {
                        "DeudaID": idFila2,
                        "InstitucionFinanciera": document.getElementById("solicitanteBancoCuentaConsolidar2").value || "0",
                        "MontoLempiras": document.getElementById("lempirasconsolidar2").value || "0",
                        "MontoDolares": document.getElementById("dolaresconsolidar2").value || "0",
                        "TotalLempiras": document.getElementById("total-lempiras-consolidar-2").value || "0",
                        "ConsolidacionTotal": document.getElementById("consolidaciontotal2").value || "0",
                        "ConsolidacionParcial": document.getElementById("consolidacionparcial2").value || "0"
                    },
                    {
                        "DeudaID": idFila3,
                        "InstitucionFinanciera": document.getElementById("solicitanteBancoCuentaConsolidar3").value || "0",
                        "MontoLempiras": document.getElementById("lempirasconsolidar3").value || "0",
                        "MontoDolares": document.getElementById("dolaresconsolidar3").value || "0",
                        "TotalLempiras": document.getElementById("total-lempiras-consolidar-3").value || "0",
                        "ConsolidacionTotal": document.getElementById("consolidaciontotal3").value || "0",
                        "ConsolidacionParcial": document.getElementById("consolidacionparcial3").value || "0"
                    },
                    {
                        "DeudaID": idFila4,
                        "InstitucionFinanciera": document.getElementById("solicitanteBancoCuentaConsolidar4").value || "0",
                        "MontoLempiras": document.getElementById("lempirasconsolidar4").value || "0",
                        "MontoDolares": document.getElementById("dolaresconsolidar4").value || "0",
                        "TotalLempiras": document.getElementById("total-lempiras-consolidar-4").value || "0",
                        "ConsolidacionTotal": document.getElementById("consolidaciontotal4").value || "0",
                        "ConsolidacionParcial": document.getElementById("consolidacionparcial4").value || "0"
                    },
                    {
                        "DeudaID": idFila5,
                        "InstitucionFinanciera": document.getElementById("solicitanteBancoCuentaConsolidar5").value || "0",
                        "MontoLempiras": document.getElementById("lempirasconsolidar5").value || "0",
                        "MontoDolares": document.getElementById("dolaresconsolidar5").value || "0",
                        "TotalLempiras": document.getElementById("total-lempiras-consolidar-5").value || "0",
                        "ConsolidacionTotal": document.getElementById("consolidaciontotal5").value || "0",
                        "ConsolidacionParcial": document.getElementById("consolidacionparcial5").value || "0"
                    },
                ],
                "voucher_pago": {
                    "ArchivoPDF": "VouchersPago.pdf"
                }
            };

            // Condiciona la inclusión de las secciones opcionales
            if (sessi.sessionData.estado !== "JUBILADO") {
                jsonOutput.informacion_laboral =
                {
                    "DependenciaTrabajo": document.getElementById("DependenciaTrabajo").value,
                    "Ramo": document.getElementById("Ramo").value,
                    "Telefono": document.getElementById("laboralTelefono").value,
                    "Direccion": "Av. Comercial",
                    "BarrioCol": document.getElementById("laboralBarrio").value,
                    "Ave": document.getElementById("laboralAve").value,
                    "Calle": document.getElementById("laboralCalle").value,
                    "CasaNo": document.getElementById("laboralCasa").value,
                    "Ciudad": document.getElementById("laboralCiudad").value,
                    "Departamento": document.getElementById("laboralDepartamento").value,
                    "SueldoMensual": document.getElementById("sueldoMensualsoli").value,
                    "OtrosIngresos": document.getElementById("otrosIngresossoli").value,
                    "SueldoNeto": document.getElementById("sueldoNetosoli").value,
                    "Puesto": document.getElementById("laboralPuesto").value,
                    "TiempoLaborarAnios": document.getElementById("laboralYears").value,
                    "TiempoLaborarMeses": document.getElementById("laboralMeses").value
                }

            }
            if (tipoPrestamo === 'Con Aval' || tipoPrestamo === 'Consolidacion de Deuda') {
                jsonOutput.datos_aval = [
                    {
                        "AvalID": idAval1,
                        "NumeroIdentidad": document.getElementById("aval1Identidad").value,
                        "Nombres": document.getElementById("aval1Nombres").value,
                        "Apellidos": document.getElementById("aval1Apellidos").value,
                        "FechaNacimiento": selectedDateAval1.toISOString().split('T')[0],
                        "Profesion": document.getElementById("aval1Profesion").value,
                        "TipoVivienda": TipoViviendaAval1,
                        "Direccion": "Col. San José",
                        "BarrioCol": document.getElementById("aval1Barrio").value,
                        "Ave": document.getElementById("aval1Ave").value,
                        "Calle": document.getElementById("aval1Calle").value,
                        "CasaNo": document.getElementById("aval1Casa").value,
                        "Ciudad": document.getElementById("aval1Ciudad").value,
                        "Departamento": document.getElementById("aval1Departamento").value,
                        "EstadoCivil": document.getElementById("estadocivilAval1").value,
                        "ReferenciaDomicilio": document.getElementById("aval1ReferenciaDomicilio").value,
                        "TelefonoFijo": document.getElementById("aval1Fijo").value,
                        "TelefonoMovil": document.getElementById("aval1Movil").value,
                        "CorreoElectronico": document.getElementById("aval1Correo").value,
                        "ArchivoPDF": "IdentidadAval1.pdf"
                    },
                    {
                        "AvalID": idAval2,
                        "NumeroIdentidad": document.getElementById("aval2Identidad").value,
                        "Nombres": document.getElementById("aval2Nombres").value,
                        "Apellidos": document.getElementById("aval2Apellidos").value,
                        "FechaNacimiento": selectedDateAval2.toISOString().split('T')[0],
                        "Profesion": document.getElementById("aval2Profesion").value,
                        "TipoVivienda": TipoViviendaAval2,
                        "Direccion": "Col. San José",
                        "BarrioCol": document.getElementById("aval2Barrio").value,
                        "Ave": document.getElementById("aval2Ave").value,
                        "Calle": document.getElementById("aval2Calle").value,
                        "CasaNo": document.getElementById("aval2Casa").value,
                        "Ciudad": document.getElementById("aval2Ciudad").value,
                        "Departamento": document.getElementById("aval2Departamento").value,
                        "EstadoCivil": document.getElementById("estadocivilAval2").value,
                        "ReferenciaDomicilio": document.getElementById("aval2ReferenciaDomicilio").value,
                        "TelefonoFijo": document.getElementById("aval2Fijo").value,
                        "TelefonoMovil": document.getElementById("aval2Movil").value,
                        "CorreoElectronico": document.getElementById("aval2Correo").value,
                        "ArchivoPDF": "IdentidadAval2.pdf"
                    }
                ];
                jsonOutput.informacion_laboral_aval = [
                    {
                        "DependenciaTrabajo": document.getElementById("aval1Dependencia").value,
                        "Ramo": document.getElementById("aval1Ramo").value,
                        "Telefono": document.getElementById("aval1TelefonoTrabajo").value,
                        "Direccion": "Av. Principal",
                        "BarrioCol": document.getElementById("aval1BarrioTrabajo").value,
                        "Ave": document.getElementById("aval1AveTrabajo").value,
                        "Calle": document.getElementById("aval1CalleTrabajo").value,
                        "CasaNo": document.getElementById("aval1CasaTrabajo").value,
                        "Ciudad": document.getElementById("aval1CiudadTrabajo").value,
                        "Departamento": document.getElementById("aval1Departamentotrabajo").value,
                        "SueldoMensual": document.getElementById("sueldoMensualAval1").value,
                        "OtrosIngresos": document.getElementById("otrosIngresosAval1").value,
                        "SueldoNeto": document.getElementById("sueldoNetoAval1").value,
                        "Puesto": document.getElementById("aval1Puesto").value,
                        "TiempoLaborarAnios": document.getElementById("aval1Years").value,
                        "TiempoLaborarMeses": document.getElementById("aval1Meses").value
                    },
                    {
                        "DependenciaTrabajo": document.getElementById("aval2Dependencia").value,
                        "Ramo": document.getElementById("aval2Ramo").value,
                        "Telefono": document.getElementById("aval2TelefonoTrabajo").value,
                        "Direccion": "Av. Principal",
                        "BarrioCol": document.getElementById("aval2BarrioTrabajo").value,
                        "Ave": document.getElementById("aval2AveTrabajo").value,
                        "Calle": document.getElementById("aval2CalleTrabajo").value,
                        "CasaNo": document.getElementById("aval2CasaTrabajo").value,
                        "Ciudad": document.getElementById("aval2CiudadTrabajo").value,
                        "Departamento": document.getElementById("aval2Departamentotrabajo").value,
                        "SueldoMensual": document.getElementById("sueldoMensualAval2").value,
                        "OtrosIngresos": document.getElementById("otrosIngresosAval2").value,
                        "SueldoNeto": document.getElementById("sueldoNetoAval2").value,
                        "Puesto": document.getElementById("aval2Puesto").value,
                        "TiempoLaborarAnios": document.getElementById("aval2Years").value,
                        "TiempoLaborarMeses": document.getElementById("aval2Meses").value
                    }
                ];
            }

            //console.log(jsonOutput);
            let token = sessi.sessionData.token;
            handleOpen(true);
            sendDataSolicitud(token, sessi.ip, jsonOutput, files, handleClose);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedFile(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedIdentidadSoli(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedFile(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setSelectedIdentidadSoli(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleClick = () => {
        document.getElementById('fileInput').click();
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadSoli').click();
    };

    const handleLempirasBlur = (event, rowIndex) => {
        let lempirasValue = event.target.value.replace(/,/g, ''); // Eliminar comas
        if (lempirasValue === '') {
            lempirasValue = 0;
        }

        let dolaresValue = document.getElementById(`dolaresconsolidar${rowIndex}`).value.replace(/,/g, ''); // Eliminar comas
        if (dolaresValue === '') {
            dolaresValue = 0;
        }
        const conversionRate = 24.67; // Tasa de conversión de dólares a lempiras

        // Calcula el Total Lempiras
        const totalLempiras = (parseFloat(dolaresValue) * conversionRate);
        document.getElementById(`total-lempiras-consolidar-${rowIndex}`).value = totalLempiras.toFixed(2);

        // Calcula y actualiza el Total
        const total = parseFloat(document.getElementById(`lempirasconsolidar${rowIndex}`).value.replace(/,/g, '')) + totalLempiras;
        document.getElementById(`consolidaciontotal${rowIndex}`).value = total.toFixed(2);
        setConsolidacionTotal(total);
    };

    const calcularTotales = () => {
        let totalLempiras = 0;
        let totalDolares = 0;
        let totalTotalLempiras = 0;
        let totalTotal = 0;
        let totalParcial = 0;

        // Iterar sobre cada fila de la tabla
        [1, 2, 3, 4, 5].forEach(rowIndex => {
            // Obtener los valores de los campos de la fila actual, eliminando las comas
            const lempirasValue = parseFloat(document.getElementById(`lempirasconsolidar${rowIndex}`).value.replace(/,/g, '')) || 0;
            const dolaresValue = parseFloat(document.getElementById(`dolaresconsolidar${rowIndex}`).value.replace(/,/g, '')) || 0;
            const totalLempirasValue = parseFloat(document.getElementById(`total-lempiras-consolidar-${rowIndex}`).value.replace(/,/g, '')) || 0;
            const totalValue = parseFloat(document.getElementById(`consolidaciontotal${rowIndex}`).value.replace(/,/g, '')) || 0;
            const parcialValue = parseFloat(document.getElementById(`consolidacionparcial${rowIndex}`).value.replace(/,/g, '')) || 0;

            // Sumar los valores a los totales globales
            totalLempiras += lempirasValue;
            totalDolares += dolaresValue;
            totalTotalLempiras += totalLempirasValue;
            totalTotal += totalValue;
            totalParcial += parcialValue;
        });

        // Actualizar los campos de la fila "TOTAL DEL PRÉSTAMO" con las sumas calculadas
        document.getElementById(`lempirasconsolidar`).value = totalLempiras.toFixed(2);
        document.getElementById(`dolaresconsolidar`).value = totalDolares.toFixed(2);
        document.getElementById(`total-lempiras-consolidar`).value = totalTotalLempiras.toFixed(2);
        document.getElementById(`consolidaciontotal`).value = totalTotal.toFixed(2);
        document.getElementById(`consolidacionparcial`).value = totalParcial.toFixed(2);
    };



    const [open, setOpen] = React.useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogErrores, setOpenDialogErrores] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        navigate('/Mis Solicitudes/MisSolicitudes');
    };

    const handleCloseDialogErrores = () => {
        setOpenDialogErrores(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    React.useEffect(() => {
        const container = document.getElementById('my-container');
        container.style.zoom = "80%";

        async function fetchData() {
            let token = sessi.sessionData.token;
            setEstadoParticipante(sessi.sessionData.estado);
            let sid = sessi.getVariable("SolicitudPrestamo");
            setSolicitudIDenviar(sid);
            const data = await getSolicitudInfo(token, sessi.ip, sid);
            //console.log(`El SolicitudID Es: ${sid}`);
            setFilas(data);
            setLoading(false);
            //console.log("FILAS ", data);

            //Asignar valores a los TextField

            //Datos Del  
            const response = await getSolicitudInfo(sessi.sessionData.token, sessi.ip, sessi.getVariable("SolicitudPrestamo"));
            //console.log("resultado de la SOLICITUD es: !!", response.Solicitud, response);
            if (response.Solicitud && response.Solicitud[0]) {

                response.Solicitud[0].NumeroSolicitud !== undefined && setNumeroSolicitud(response.Solicitud[0].NumeroSolicitud);
                response.Solicitud[0].NumeroCotizante !== undefined && setNumeroCotizante(response.Solicitud[0].NumeroCotizante);
                response.Solicitud[0].TipoPrestamo !== undefined && setTipoPrestamo(response.Solicitud[0].TipoPrestamo);
                response.Solicitud[0].MontoSolicitado !== undefined && setMontoSolicitado(response.Solicitud[0].MontoSolicitado);

            }

            if (response.DatosSolicitante && response.DatosSolicitante[0]) {
                response.DatosSolicitante[0].NumeroIdentidad !== undefined && setIdentidadSolicitante(response.DatosSolicitante[0].NumeroIdentidad);
                response.DatosSolicitante[0].Nombres !== undefined && setNombresSolicitante(response.DatosSolicitante[0].Nombres);
                response.DatosSolicitante[0].Apellidos !== undefined && setApellidosSolicitante(response.DatosSolicitante[0].Apellidos);
                response.DatosSolicitante[0].FechaNacimiento !== undefined && setSelectedDate(response.DatosSolicitante[0].FechaNacimiento);
                response.DatosSolicitante[0].Profesion !== undefined && setProfesionSolicitante(response.DatosSolicitante[0].Profesion);
                response.DatosSolicitante[0].TipoVivienda !== undefined && setTipoViviendaSolicitante(response.DatosSolicitante[0].TipoVivienda);
                response.DatosSolicitante[0].BarrioCol !== undefined && setBarrioSolicitante(response.DatosSolicitante[0].BarrioCol);
                response.DatosSolicitante[0].Ave !== undefined && setAvenidaSolicitante(response.DatosSolicitante[0].Ave);
                response.DatosSolicitante[0].Calle !== undefined && setCalleSolicitante(response.DatosSolicitante[0].Calle);
                response.DatosSolicitante[0].CasaNo !== undefined && setCasaSolicitante(response.DatosSolicitante[0].CasaNo);
                response.DatosSolicitante[0].Ciudad !== undefined && setCiudadSolicitante(response.DatosSolicitante[0].Ciudad);
                response.DatosSolicitante[0].Departamento !== undefined && setDepartamentoSolicitante(response.DatosSolicitante[0].Departamento);
                response.DatosSolicitante[0].EstadoCivil !== undefined && setEstadoCivilSolicitante(response.DatosSolicitante[0].EstadoCivil);
                response.DatosSolicitante[0].ReferenciaDomicilio !== undefined && setReferenciaDomicilioSolicitante(response.DatosSolicitante[0].ReferenciaDomicilio);
                response.DatosSolicitante[0].TelefonoFijo !== undefined && setFijoSolicitante(response.DatosSolicitante[0].TelefonoFijo);
                response.DatosSolicitante[0].TelefonoMovil !== undefined && setMovilSolicitante(response.DatosSolicitante[0].TelefonoMovil);
                response.DatosSolicitante[0].CorreoElectronico !== undefined && setCorreoSolicitante(response.DatosSolicitante[0].CorreoElectronico);
            }

            //datos de la solicitud
            if (response.Solicitud && response.Solicitud[0]) {
                setEstadoSolicitud(response.Solicitud[0].aprobado);
                setFaseSolicitud(response.Solicitud[0].Estado ?? '');
                setObservacion(response.Solicitud[0].observacion ?? '');
                setIDenviar(response.Solicitud[0].SolicitudID ?? '');
            }

            //Informacion laboral del solicitante
            if (sessi.sessionData.estado !== "JUBILADO") {
                if (response.InformacionLaboral && response.InformacionLaboral[0]) {
                    //setSolicitante(response.InformacionLaboral[0].);
                    response.InformacionLaboral[0].DependenciaTrabajo !== undefined && setDependenciaSolicitante(response.InformacionLaboral[0].DependenciaTrabajo);
                    response.InformacionLaboral[0].Ramo !== undefined && setRamoSolicitante(response.InformacionLaboral[0].Ramo);
                    response.InformacionLaboral[0].Telefono !== undefined && setTelefonoLaboralSolicitante(response.InformacionLaboral[0].Telefono);
                    response.InformacionLaboral[0].BarrioCol !== undefined && setBarrioLaboralSolicitante(response.InformacionLaboral[0].BarrioCol);
                    response.InformacionLaboral[0].Ave !== undefined && setAvenidaLaboralSolicitante(response.InformacionLaboral[0].Ave);
                    response.InformacionLaboral[0].Calle !== undefined && setCalleLaboralSolicitante(response.InformacionLaboral[0].Calle);
                    response.InformacionLaboral[0].CasaNo !== undefined && setCasaLaboralSolicitante(response.InformacionLaboral[0].CasaNo);
                    response.InformacionLaboral[0].Ciudad !== undefined && setCiudadLaboralSolicitante(response.InformacionLaboral[0].Ciudad);
                    response.InformacionLaboral[0].Departamento !== undefined && setDepartamentoLaboralSolicitante(response.InformacionLaboral[0].Departamento);
                    response.InformacionLaboral[0].SueldoMensual !== undefined && setSueldoMensualSolicitante(response.InformacionLaboral[0].SueldoMensual);
                    response.InformacionLaboral[0].OtrosIngresos !== undefined && setOtrosIngresosSolicitante(response.InformacionLaboral[0].OtrosIngresos);
                    response.InformacionLaboral[0].SueldoNeto !== undefined && setSueldoNetoSolicitante(response.InformacionLaboral[0].SueldoNeto);
                    response.InformacionLaboral[0].Puesto !== undefined && setPuestoSolicitante(response.InformacionLaboral[0].Puesto);
                    response.InformacionLaboral[0].TiempoLaborarAnios !== undefined && setTiempoLaborarASolicitante(response.InformacionLaboral[0].TiempoLaborarAnios);
                    response.InformacionLaboral[0].TiempoLaborarMeses !== undefined && setTiempoLaborarMSolicitante(response.InformacionLaboral[0].TiempoLaborarMeses);
                }
            }

            //Referencias Personales
            if (response.ReferenciasPersonales[0]) {
                response.ReferenciasPersonales[0].ReferenciaID !== undefined && setIdReferencia1(response.ReferenciasPersonales[0].ReferenciaID);
                response.ReferenciasPersonales[0].Nombre !== undefined && setReferencia1(response.ReferenciasPersonales[0].Nombre);
                response.ReferenciasPersonales[0].Parentesco !== undefined && setParentescoReferencia1(response.ReferenciasPersonales[0].Parentesco);
                response.ReferenciasPersonales[0].Direccion !== undefined && setDireccionReferencia1(response.ReferenciasPersonales[0].Direccion);
                response.ReferenciasPersonales[0].Telefono !== undefined && setTelefonoReferencia1(response.ReferenciasPersonales[0].Telefono);
            }
            if (response.ReferenciasPersonales[1]) {
                response.ReferenciasPersonales[1].ReferenciaID !== undefined && setIdReferencia2(response.ReferenciasPersonales[1].ReferenciaID);
                response.ReferenciasPersonales[1].Nombre !== undefined && setReferencia2(response.ReferenciasPersonales[1].Nombre);
                response.ReferenciasPersonales[1].Parentesco !== undefined && setParentescoReferencia2(response.ReferenciasPersonales[1].Parentesco);
                response.ReferenciasPersonales[1].Direccion !== undefined && setDireccionReferencia2(response.ReferenciasPersonales[1].Direccion);
                response.ReferenciasPersonales[1].Telefono !== undefined && setTelefonoReferencia2(response.ReferenciasPersonales[1].Telefono);
            }

            if (response.Solicitud[0].TipoPrestamo === "Con Aval" || response.Solicitud[0].TipoPrestamo === "Consolidacion de Deuda") {

                //Aval1
                setIdAval1(response.DatosAval[0].AvalID ?? '');
                setIdentidadAval1(response.DatosAval[0].NumeroIdentidad);
                setNombresAval1(response.DatosAval[0].Nombres);
                setApellidosAval1(response.DatosAval[0].Apellidos);
                setNacimientoAval1(response.DatosAval[0].FechaNacimiento ?? '');
                setProfesionAval1(response.DatosAval[0].Profesion ?? '');
                setTipoViviendaAval1(response.DatosAval[0].TipoVivienda ?? '');
                setBarrioAval1(response.DatosAval[0].BarrioCol ?? '');
                setAvenidaAval1(response.DatosAval[0].Ave ?? '');
                setCalleAval1(response.DatosAval[0].Calle ?? '');
                setCasaAval1(response.DatosAval[0].CasaNo ?? '');
                setCiudadAval1(response.DatosAval[0].Ciudad ?? '');
                setDepartamentoAval1(response.DatosAval[0].Departamento ?? '');
                setEstadoCivilAval1(response.DatosAval[0].EstadoCivil ?? '');
                setReferenciaDomicilioAval1(response.DatosAval[0].ReferenciaDomicilio ?? '');
                setFijoAval1(response.DatosAval[0].TelefonoFijo ?? '');
                setMovilAval1(response.DatosAval[0].TelefonoMovil ?? '');
                setCorreoAval1(response.DatosAval[0].CorreoElectronico ?? '');
                setDependenciaAval1(response.InformacionLaboralAval[0].DependenciaTrabajo ?? '');
                setRamoAval1(response.InformacionLaboralAval[0].Ramo ?? '');
                setTelefonoLaboralAval1(response.InformacionLaboralAval[0].Telefono ?? '');
                setBarrioLaboralAval1(response.InformacionLaboralAval[0].BarrioCol ?? '');
                setAvenidaLaboralAval1(response.InformacionLaboralAval[0].Ave ?? '');
                setCalleLaboralAval1(response.InformacionLaboralAval[0].Calle ?? '');
                setCasaLaboralAval1(response.InformacionLaboralAval[0].CasaNo ?? '');
                setCiudadLaboralAval1(response.InformacionLaboralAval[0].Ciudad ?? '');
                setDepartamentoLaboralAval1(response.InformacionLaboralAval[0].Departamento ?? '');
                setSueldoMensualAval1(response.InformacionLaboralAval[0].SueldoMensual ?? '');
                setOtrosIngresosAval1(response.InformacionLaboralAval[0].OtrosIngresos ?? '');
                setSueldoNetoAval1(response.InformacionLaboralAval[0].SueldoNeto ?? '');
                setPuestoAval1(response.InformacionLaboralAval[0].Puesto ?? '');
                setTiempoLaborarAAval1(response.InformacionLaboralAval[0].TiempoLaborarAnios ?? '');
                setTiempoLaborarMAval1(response.InformacionLaboralAval[0].TiempoLaborarMeses ?? '');


                if (response.DatosAval && response.DatosAval[1]) {
                    //Aval 2
                    setIdAval2(response.DatosAval[1].AvalID ?? '');
                    setIdentidadAval2(response.DatosAval[1].NumeroIdentidad ?? '');
                    setNombresAval2(response.DatosAval[1].Nombres ?? '');
                    setApellidosAval2(response.DatosAval[1].Apellidos ?? '');
                    setNacimientoAval2(response.DatosAval[1].FechaNacimiento ?? '');
                    setProfesionAval2(response.DatosAval[1].Profesion ?? '');
                    setTipoViviendaAval2(response.DatosAval[1].TipoVivienda ?? '');
                    setBarrioAval2(response.DatosAval[1].BarrioCol ?? '');
                    setAvenidaAval2(response.DatosAval[1].Ave ?? '');
                    setCalleAval2(response.DatosAval[1].Calle ?? '');
                    setCasaAval2(response.DatosAval[1].CasaNo ?? '');
                    setCiudadAval2(response.DatosAval[1].Ciudad ?? '');
                    setDepartamentoAval2(response.DatosAval[1].Departamento ?? '');
                    setEstadoCivilAval2(response.DatosAval[1].EstadoCivil ?? '');
                    setReferenciaDomicilioAval2(response.DatosAval[1].ReferenciaDomicilio ?? '');
                    setFijoAval2(response.DatosAval[1].TelefonoFijo ?? '');
                    setMovilAval2(response.DatosAval[1].TelefonoMovil ?? '');
                    setCorreoAval2(response.DatosAval[1].CorreoElectronico ?? '');
                    setDependenciaAval2(response.InformacionLaboralAval[1].DependenciaTrabajo ?? '');
                    setRamoAval2(response.InformacionLaboralAval[1].Ramo ?? '');
                    setTelefonoLaboralAval2(response.InformacionLaboralAval[1].Telefono ?? '');
                    setBarrioLaboralAval2(response.InformacionLaboralAval[1].BarrioCol ?? '');
                    setAvenidaLaboralAval2(response.InformacionLaboralAval[1].Ave ?? '');
                    setCalleLaboralAval2(response.InformacionLaboralAval[1].Calle ?? '');
                    setCasaLaboralAval2(response.InformacionLaboralAval[1].CasaNo ?? '');
                    setCiudadLaboralAval2(response.InformacionLaboralAval[1].Ciudad ?? '');
                    setDepartamentoLaboralAval2(response.InformacionLaboralAval[1].Departamento ?? '');
                    setSueldoMensualAval2(response.InformacionLaboralAval[1].SueldoMensual ?? '');
                    setOtrosIngresosAval2(response.InformacionLaboralAval[1].OtrosIngresos ?? '');
                    setSueldoNetoAval2(response.InformacionLaboralAval[1].SueldoNeto ?? '');
                    setPuestoAval2(response.InformacionLaboralAval[1].Puesto ?? '');
                    setTiempoLaborarAAval2(response.InformacionLaboralAval[1].TiempoLaborarAnios ?? '');
                    setTiempoLaborarMAval2(response.InformacionLaboralAval[1].TiempoLaborarMeses ?? '');
                }
            }

            //TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA
            if (response.TransferenciaPago && response.TransferenciaPago[0]) {
                response.TransferenciaPago[0].TipoCuenta !== undefined && setTipoCuenta(response.TransferenciaPago[0].TipoCuenta);
                response.TransferenciaPago[0].Banco !== undefined && setNombreBanco(response.TransferenciaPago[0].Banco);
                response.TransferenciaPago[0].NoCuenta !== undefined && setNoCuenta(response.TransferenciaPago[0].NoCuenta);
            }

            //Deudas A Consolidar
            //fila 1
            if (response.DeudasConsolidar && response.DeudasConsolidar[0]) {
                response.DeudasConsolidar[0].DeudaID !== undefined && setIdFila1(response.DeudasConsolidar[0].DeudaID);
                response.DeudasConsolidar[0].InstitucionFinanciera !== undefined && setInstitucionNombre1(response.DeudasConsolidar[0].InstitucionFinanciera);
                response.DeudasConsolidar[0].MontoLempiras !== undefined && setMontoLempiras1(response.DeudasConsolidar[0].MontoLempiras);
                response.DeudasConsolidar[0].MontoDolares !== undefined && setMontoDolares1(response.DeudasConsolidar[0].MontoDolares);
                response.DeudasConsolidar[0].TotalLempiras !== undefined && setTotalLempiras1(response.DeudasConsolidar[0].TotalLempiras);
                response.DeudasConsolidar[0].ConsolidacionTotal !== undefined && setConsolidacionTotal1(response.DeudasConsolidar[0].ConsolidacionTotal);
                response.DeudasConsolidar[0].ConsolidacionParcial !== undefined && setConsolidacionParcial1(response.DeudasConsolidar[0].ConsolidacionParcial);
            }
            //fila 2
            if (response.DeudasConsolidar && response.DeudasConsolidar[1]) {
                setIdFila2(response.DeudasConsolidar[1].DeudaID ?? '');
                setInstitucionNombre2(response.DeudasConsolidar[1].InstitucionFinanciera ?? '');
                setMontoLempiras2(response.DeudasConsolidar[1].MontoLempiras ?? '');
                setMontoDolares2(response.DeudasConsolidar[1].MontoDolares ?? '');
                setTotalLempiras2(response.DeudasConsolidar[1].TotalLempiras ?? '');
                setConsolidacionTotal2(response.DeudasConsolidar[1].ConsolidacionTotal ?? '');
                setConsolidacionParcial2(response.DeudasConsolidar[1].ConsolidacionParcial ?? '');
            }

            //fila 3
            if (response.DeudasConsolidar && response.DeudasConsolidar[2]) {
                setIdFila3(response.DeudasConsolidar[2].DeudaID ?? '');
                setInstitucionNombre3(response.DeudasConsolidar[2].InstitucionFinanciera ?? '');
                setMontoLempiras3(response.DeudasConsolidar[2].MontoLempiras ?? '');
                setMontoDolares3(response.DeudasConsolidar[2].MontoDolares ?? '');
                setTotalLempiras3(response.DeudasConsolidar[2].TotalLempiras ?? '');
                setConsolidacionTotal3(response.DeudasConsolidar[2].ConsolidacionTotal ?? '');
                setConsolidacionParcial3(response.DeudasConsolidar[2].ConsolidacionParcial ?? '');
            }

            //fila 4
            if (response.DeudasConsolidar && response.DeudasConsolidar[3]) {
                setIdFila4(response.DeudasConsolidar[3].DeudaID ?? '');
                setInstitucionNombre4(response.DeudasConsolidar[3].InstitucionFinanciera ?? '');
                setMontoLempiras4(response.DeudasConsolidar[3].MontoLempiras ?? '');
                setMontoDolares4(response.DeudasConsolidar[3].MontoDolares ?? '');
                setTotalLempiras4(response.DeudasConsolidar[3].TotalLempiras ?? '');
                setConsolidacionTotal4(response.DeudasConsolidar[3].ConsolidacionTotal ?? '');
                setConsolidacionParcial4(response.DeudasConsolidar[3].ConsolidacionParcial ?? '');
            }

            //fila 5
            if (response.DeudasConsolidar && response.DeudasConsolidar[4]) {
                setIdFila5(response.DeudasConsolidar[4].DeudaID ?? '');
                setInstitucionNombre5(response.DeudasConsolidar[4].InstitucionFinanciera ?? '');
                setMontoLempiras5(response.DeudasConsolidar[4].MontoLempiras ?? '');
                setMontoDolares5(response.DeudasConsolidar[4].MontoDolares ?? '');
                setTotalLempiras5(response.DeudasConsolidar[4].TotalLempiras ?? '');
                setConsolidacionTotal5(response.DeudasConsolidar[4].ConsolidacionTotal ?? '');
                setConsolidacionParcial5(response.DeudasConsolidar[4].ConsolidacionParcial ?? '');
            }

            /*if (response.TotalesPrestamo[0]) {
                //fila 6 totales
                setTotalMontoLempiras1(response.TotalesPrestamo[0].TotalMontoLempiras ?? '');
                setTotalMontoDolares1(response.TotalesPrestamo[0].TotalMontoDolares ?? '');
                setTotalTotalLempiras1(response.TotalesPrestamo[0].TotalTotalLempiras ?? '');
                setTotalConsolidacionTotal1(response.TotalesPrestamo[0].TotalConsolidacionTotal ?? '');
                setTotalConsolidacionParcial1(response.TotalesPrestamo[0].TotalConsolidacionParcial ?? '');
            }*/

            /*if (response.TotalesMontoAFavor[0]) {
                //fila 7 total monto a favor
                setTotalMontoLempiras2(response.TotalesMontoAFavor[0].TotalMontoLempiras ?? '');
                setTotalMontoDolares2(response.TotalesMontoAFavor[0].TotalMontoDolares ?? '');
                setTotalTotalLempiras2(response.TotalesMontoAFavor[0].TotalTotalLempiras ?? '');
                setTotalConsolidacionTotal2(response.TotalesMontoAFavor[0].TotalConsolidacionTotal ?? '');
                setTotalConsolidacionParcial2(response.TotalesMontoAFavor[0].TotalConsolidacionParcial ?? '');
            }*/

        }
        fetchData();
    }, []);

    return (<>
        <div id="my-container">
            <Container style={{ marginTop: 50 }} >
                <Stack direction="row">
                    <Grid spacing={2} container>
                        <Grid item xs={10} md={2.2} >
                            {/*<img style={{ width: 200, height: 'auto' }} src={logoblack} />*/}
                        </Grid>
                        <Grid style={{ textAlign: 'center' }} item xs={4} md={5.8}>
                            <h3>DPP-F-04.2</h3>
                            <h1>SOLICITUD DE PRÉSTAMO</h1>
                        </Grid>
                        <Grid item xs={4} md={4}>
                            <Stack>
                                <Box>
                                    <label style={{ marginRight: 10 }}>No. Solicitud: </label>
                                    <TextField id="NoSolicitud" variant="standard" value={numeroSolicitud} InputProps={{ readOnly: true }} />

                                </Box>
                                <Box>
                                    <label style={{ marginRight: 10, visibility: 'hidden' }}>No. Cotizante:</label>
                                    <TextField id="SolicitanteID" variant="standard" style={{ visibility: 'hidden' }} />
                                </Box>
                            </Stack>
                        </Grid>
                    </Grid>
                </Stack>

                <Stack direction="row" alignItems="center">
                    <label style={{ marginRight: 10 }}><strong>TIPO DE PRÉSTAMO:</strong></label>
                    <label>{tipoPrestamo}</label>
                </Stack>
                <Divider />
                <Stack direction="row" alignItems="center">
                    <h3 style={{ marginRight: 10 }}>MONTO A SOLICITAR:</h3>
                    <FormControl sx={{ m: 1, width: 200 }}>
                        <TextField id="montosolicitado" variant="filled" value={montoSolicitado} InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        />
                    </FormControl>
                </Stack>

                <Box>
                    <Stack direction="row">
                        <h3 >I. DATOS DEL SOLICITANTE</h3>
                    </Stack>

                    <Stack direction="row">
                        <Grid container spacing={1}>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField
                                    id="NumeroIdentidad"
                                    label="Numero de Identidad"
                                    variant="filled"
                                    value={sessi.sessionData.identidad}
                                    //onChange={handleChangeValor}
                                    onInput={validarSoloNumeros}
                                    InputProps={{ readOnly: true }}
                                    error={Boolean(errors.NumeroIdentidad)}
                                    onBlur={handleBlur}
                                    helperText={errors.NumeroIdentidad}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField
                                    id="Nombres"
                                    label="Nombres"
                                    value={nombresSolicitante}
                                    variant="filled"
                                    onInput={validarSoloLetras}
                                    error={Boolean(errors.Nombres)}
                                    onBlur={handleBlur}
                                    helperText={errors.Nombres}
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="Apellidos" label="Apellidos" variant="filled" onInput={validarSoloLetras} error={Boolean(errors.Apellidos)}
                                    value={apellidosSolicitante}
                                    onBlur={handleBlur}
                                    helperText={errors.Apellidos}
                                    InputProps={{ readOnly: true }}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="solicitanteNacimiento" value={selectedDate}
                                    variant="filled"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <CalendarIcon />
                                            </InputAdornment>
                                        ),
                                        readOnly: true
                                    }}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="Profesion" label="Profesión u Oficio" variant="standard" onInput={validarSoloLetras}
                                    error={Boolean(errors.Profesion)}
                                    onBlur={handleBlur}
                                    helperText={errors.Profesion} />
                            </FormControl>
                        </Grid>

                    </Stack>

                    <Stack className={classes.above} direction="row" >
                        <Grid container>
                            <Box >
                                <FormControl  >
                                    <label>TIPO DE VIVIENDA</label>
                                    <RadioGroup row aria-labelledby="Tipo Vivienda" name="TipoVivienda"
                                        onChange={handleTipoVivienda}>
                                        <FormControlLabel value="Propia" control={<Radio color="error" />} label="Propia" />
                                        <FormControlLabel value="Familiar" control={<Radio color="error" />} label="Familiar" />
                                        <FormControlLabel value="Alquilada" control={<Radio color="error" />} label="Alquilada" />
                                    </RadioGroup>
                                </FormControl>
                            </Box>
                        </Grid>
                    </Stack>

                    <Stack className={classes.above} direction="row">
                        <Grid Container>

                            <Box>
                                <label>Direccion</label>
                                <Box>
                                    <Stack direction="row">
                                        <Box sx={{ width: 200 }}>
                                            <TextField id="BarrioCol" label="Barrio/Col." variant="standard"
                                                error={Boolean(errors.BarrioCol)}
                                                onBlur={handleBlur}
                                                helperText={errors.BarrioCol} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="Ave" label="Ave." variant="standard"
                                                error={Boolean(errors.Ave)}
                                                onBlur={handleBlur}
                                                helperText={errors.Ave} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="Calle" label="Calle" variant="standard"
                                                error={Boolean(errors.Calle)}
                                                onBlur={handleBlur}
                                                helperText={errors.Calle} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="CasaNo" label="Casa No." variant="standard" onInput={validarSoloNumeros}//{validarSoloNumerosComa}
                                                error={Boolean(errors.CasaNo)}
                                                onBlur={handleBlur}
                                                helperText={errors.CasaNo} />
                                        </Box>

                                        <Box sx={{ width: 200 }}>
                                            <TextField id="Ciudad" label="Ciudad" variant="standard"
                                                error={Boolean(errors.Ciudad)}
                                                onBlur={handleBlur}
                                                helperText={errors.Ciudad} />
                                        </Box>

                                        <Box sx={{ width: 220 }}>
                                            <Autocomplete
                                                id="Departamento"
                                                {...defaultProps}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        id="Departamento"
                                                        label="Departamento"
                                                        variant="standard"
                                                        error={Boolean(errors.Departamento)}
                                                        onBlur={handleBlur}
                                                        helperText={errors.Departamento}
                                                    />
                                                )}
                                            />
                                        </Box>
                                    </Stack>
                                </Box>
                            </Box>
                            <Box>

                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <Autocomplete
                                        {...defaultPropsCivil}
                                        id="EstadoCivil"
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Estado Civil"
                                                variant="standard"
                                                error={Boolean(errors.EstadoCivil)}
                                                onBlur={handleBlur}
                                                helperText={errors.EstadoCivil}
                                            />
                                        )}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 800 }}>
                                    <TextField id="Direccion" label="Referencia Domicilio" variant="standard"
                                        error={Boolean(errors.Direccion)}
                                        onBlur={handleBlur}
                                        helperText={errors.Direccion} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="TelefonoFijo" label="Teléfono Fijo" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        error={Boolean(errors.TelefonoFijo)}
                                        onBlur={handleBlur}
                                        helperText={errors.TelefonoFijo} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }} >
                                    <TextField id="TelefonoMovil" label="Teléfono Móvil" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        error={Boolean(errors.TelefonoMovil)}
                                        onBlur={handleBlur}
                                        helperText={errors.TelefonoMovil} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }} >
                                    <TextField id="CorreoElectronico" label="Correo Electrónico" variant="standard"
                                        error={Boolean(errors.CorreoElectronico)}
                                        onBlur={handleBlur}
                                        helperText={errors.CorreoElectronico} />
                                </FormControl>
                            </Box>

                            <Box marginTop={5}>
                                <h3>COPIA DE LA IDENTIDAD EN FORMATO PDF</h3>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    onDragOver={handleDragOverIdentidadSoli}
                                    onDrop={handleDropIdentidadSoli}
                                >
                                    <Box
                                        style={{
                                            padding: '50px',
                                            width: '700px',
                                            textAlign: 'center',
                                            borderColor: selectedIdentidadSoli ? 'green' : '#a0a0a0',
                                            borderRadius: 5,
                                            borderWidth: 5,
                                            borderStyle: 'dashed',
                                        }}
                                    >
                                        <Tooltip
                                            title={
                                                <div style={{ textAlign: 'center' }}>
                                                    <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                                    <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                                </div>
                                            }
                                            interactive
                                        >
                                            <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                                        </Tooltip>
                                        <br />
                                        <Button
                                            variant="contained"
                                            onClick={handleClickIdentidadSoli}
                                            style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                                        >
                                            Seleccionar Identidad En PDF
                                        </Button>
                                        <input
                                            id="selectedIdentidadSoli"
                                            type="file"
                                            accept=".pdf"
                                            style={{ display: 'none' }}
                                            onChange={handleFileChangeIdentidadSoli}
                                        />
                                        {!selectedIdentidadSoli && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                                        {selectedIdentidadSoli && <p>Archivo seleccionado: {selectedIdentidadSoli.name}</p>}
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Stack>
                </Box>
                <Divider style={{ marginTop: 5 }} />
                {sessi.sessionData.estado !== "JUBILADO" && (
                    <Box marginTop={5}>
                        <Stack direction="row">
                            <h3 >II. INFORMACIÓN LABORAL (participantes activos)</h3>
                        </Stack>

                        <Stack direction="row">
                            <Grid container>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <Autocomplete
                                        id="DependenciaTrabajo"
                                        options={options}
                                        loading={loading}
                                        onChange={handleDependenciaChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Dependencia donde Trabaja"
                                                variant="standard"
                                                error={Boolean(errors.DependenciaTrabajo)}
                                                onBlur={handleBlur}
                                                helperText={errors.DependenciaTrabajo}
                                            />
                                        )}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <TextField
                                        id="Ramo"
                                        label="Ramo"
                                        variant="standard"
                                        value={ramo}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        error={Boolean(errors.Ramo)}
                                        //onBlur={handleBlur}
                                        helperText={errors.Ramo}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 350 }}>
                                    <TextField id="laboralTelefono" label="Teléfono" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        error={Boolean(errors.laboralTelefono)}
                                        onBlur={handleBlur}
                                        helperText={errors.laboralTelefono} />
                                </FormControl>
                                <Box>
                                    <label>Direccion</label>
                                    <Box>
                                        <Stack direction="row">
                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralBarrio" label="Barrio/Col." variant="standard"
                                                    error={Boolean(errors.laboralBarrio)}
                                                    onBlur={handleBlur}
                                                    helperText={errors.laboralBarrio} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralAve" label="Ave." variant="standard"
                                                    error={Boolean(errors.laboralAve)}
                                                    onBlur={handleBlur}
                                                    helperText={errors.laboralAve} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralCalle" label="Calle" variant="standard"
                                                    error={Boolean(errors.laboralCalle)}
                                                    onBlur={handleBlur}
                                                    helperText={errors.laboralCalle} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralCasa" label="Casa No." variant="standard"
                                                    error={Boolean(errors.laboralCasa)}
                                                    onBlur={handleBlur}
                                                    helperText={errors.laboralCasa} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <TextField id="laboralCiudad" label="Ciudad" variant="standard"
                                                    error={Boolean(errors.laboralCiudad)}
                                                    onBlur={handleBlur}
                                                    helperText={errors.laboralCiudad} />
                                            </Box>

                                            <Box sx={{ width: 200 }}>
                                                <Autocomplete
                                                    {...defaultProps}
                                                    id="laboralDepartamento"
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Departamento"
                                                            variant="standard"
                                                            error={Boolean(errors.laboralDepartamento)}
                                                            onBlur={handleBlur}
                                                            helperText={errors.laboralDepartamento}
                                                        />
                                                    )}
                                                />
                                            </Box>
                                        </Stack>
                                    </Box>
                                </Box>

                                <FormControl sx={{ m: 1, width: 200 }}>
                                    <TextField id="sueldoMensualsoli" label="Sueldo Mensual" variant="standard" onInput={validarSoloNumeros /*validarSoloNumerosComa*/} InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                L.
                                            </InputAdornment>
                                        ),
                                    }}
                                        error={Boolean(errors.sueldoMensualsoli)}
                                        onBlur={handleBlur}
                                        helperText={errors.sueldoMensualsoli} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="otrosIngresossoli" onInput={validarSoloNumeros/*validarSoloNumerosComa*/} label="Otros Ingresos (detalle)" variant="standard" InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                L.
                                            </InputAdornment>
                                        ),
                                    }}
                                        error={Boolean(errors.otrosIngresossoli)}
                                        onBlur={handleBlur}
                                        helperText={errors.otrosIngresossoli} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 200 }}>
                                    <TextField id="sueldoNetosoli" onInput={validarSoloNumeros/*validarSoloNumerosComa*/} label="Sueldo Neto" variant="standard" InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                L.
                                            </InputAdornment>
                                        ),
                                    }}
                                        error={Boolean(errors.sueldoNetosoli)}
                                        onBlur={handleBlur}
                                        helperText={errors.sueldoNetosoli} />
                                </FormControl>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="laboralPuesto" label="Puesto" variant="standard"
                                        error={Boolean(errors.laboralPuesto)}
                                        onBlur={handleBlur}
                                        helperText={errors.laboralPuesto} />
                                </FormControl>
                                <Box>

                                    <Box>
                                        <label>Tiempo Laborar</label>
                                    </Box>
                                    <FormControl sx={{ m: 1, width: 300 }}>
                                        <TextField id="laboralYears" label="Años" variant="standard"
                                            error={Boolean(errors.laboralYears)}
                                            onBlur={handleBlur}
                                            helperText={errors.laboralYears} />
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 300 }}>
                                        <TextField id="laboralMeses" label="Meses" variant="standard"
                                            error={Boolean(errors.laboralMeses)}
                                            onBlur={handleBlur}
                                            helperText={errors.laboralMeses} />
                                    </FormControl>
                                </Box>
                            </Grid>

                        </Stack>
                    </Box>)}
                <Divider />

                <Stack direction="row">
                    <h3 >III. REFERENCIAS PERSONALES</h3>
                </Stack>

                <Stack>
                    <Grid>
                        <Box>
                            <TableContainer component={Paper}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>#</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 50 }} align="center">Nombre</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 200 }} align="center">Parentesco</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 300 }} align="center">Dirección</StyledTableCell>
                                            <StyledTableCell sx={{ m: 1, width: 200 }} align="center">Teléfono</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow key={1}>
                                            <StyledTableCell component="th" scope="row">1.</StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia1Nombres" variant="standard" onInput={validarSoloLetras}
                                                        //value={formulario.referencia1Nombres}
                                                        //onChange={handleChange}
                                                        error={Boolean(errors["referencia1Nombres"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia1Nombres"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia1Parentesco" variant="standard" onInput={validarSoloLetras}
                                                        error={Boolean(errors["referencia1Parentesco"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia1Parentesco"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 300 }}>
                                                    <TextField id="referencia1Direccion" variant="standard"
                                                        //value={formulario.referencia1Direccion}
                                                        //onChange={handleChange}
                                                        error={Boolean(errors["referencia1Direccion"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia1Direccion"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia1Telefono" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                                        error={Boolean(errors["referencia1Telefono"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia1Telefono"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow key={2}>
                                            <StyledTableCell component="th" scope="row">2.</StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia2Nombres" variant="standard" onInput={validarSoloLetras}
                                                        error={Boolean(errors["referencia2Nombres"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia2Nombres"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia2Parentesco" variant="standard" onInput={validarSoloLetras}
                                                        error={Boolean(errors["referencia2Parentesco"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia2Parentesco"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 300 }}>
                                                    <TextField id="referencia2Direccion" variant="standard"
                                                        error={Boolean(errors["referencia2Direccion"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia2Direccion"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <FormControl sx={{ m: 1, width: 200 }}>
                                                    <TextField id="referencia2Telefono" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                                        error={Boolean(errors["referencia2Telefono"])}
                                                        //onBlur={handleBlur}
                                                        helperText={errors["referencia2Telefono"]} />
                                                </FormControl>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Grid>
                </Stack>
                <Divider />

                {(tipoPrestamo === "Con Aval" || tipoPrestamo === "Consolidacion de Deuda" || tipoPrestamo === "all") && <>
                    <Aval
                        errorsEnviar={errors}
                        setErrors={setErrors}
                        formulario={formulario}
                        onchange={handleChange}
                        handleblurAval={handleBlur}
                        fechavaciaaval={fechaVaciaAval1}
                        setfechavaciaaval={setFechaVaciaAval1}
                        selecteddateaval={selectedDateAval1}
                        setselecteddate={setSelectedDateAval1}
                        selectedIdentidadAval1={selectedIdentidadAval1}
                        setselectedIdentidadAval1={setselectedIdentidadAval1}
                    />
                    <Divider style={{ marginTop: 5 }} />
                </>
                }
                {(tipoPrestamo === "Con Aval" || tipoPrestamo === "Consolidacion de Deuda" || tipoPrestamo === "all") && <>
                    <Aval2
                        errorsEnviar={errors}
                        setErrors={setErrors}
                        formulario={formulario}
                        onchange={handleChange}
                        handleblurAval={handleBlur}
                        fechavaciaaval={fechaVaciaAval2}
                        setfechavaciaaval={setFechaVaciaAval2}
                        selecteddateaval={selectedDateAval2}
                        setselecteddate={setSelectedDateAval2}
                        handleviviendaaval={handleTipoViviendaAval2}
                        selectedIdentidadAval2={selectedIdentidadAval2}
                        setselectedIdentidadAval2={setselectedIdentidadAval2}
                    />
                    <Divider style={{ marginTop: 5 }} />
                </>}


                <Stack direction="row">
                    <Box>
                        <Stack>
                            <h3 >VIII. TRANSFERENCIA DE PAGO DEL MONTO APROBADO A CUENTA BANCARIA</h3>
                        </Stack>
                        <h4>INFORMACION DEL BANCO</h4>
                        <Grid container>
                            <Stack direction="row">
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <label htmlFor="bancoTipoCuenta">Tipo de Cuenta </label>
                                    <RadioGroup row aria-labelledby="Tipo Cuenta Bano" name="tipoCuentaBanco"
                                        onChange={handleTipoCuentaBanco}>
                                        <FormControlLabel value="Ahorro" control={<Radio color="error" />} label="Ahorro" />
                                        <FormControlLabel value="Cheque" control={<Radio color="error" />} label="Cheque" />
                                    </RadioGroup>
                                </FormControl>
                                <Box sx={{ m: 1, width: 550 }}>
                                    <Autocomplete
                                        id="solicitanteBancoCuenta"
                                        {...defaultPropsBancos}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                id="solicitanteBancoCuenta"
                                                label="Nombre del Banco"
                                                variant="standard"
                                                error={Boolean(errors.solicitanteBancoCuenta)}
                                                onBlur={handleBlur}
                                                helperText={errors.solicitanteBancoCuenta}
                                            />
                                        )}
                                    />
                                </Box>
                                <FormControl sx={{ m: 1, width: 300 }}>
                                    <TextField id="nocuenta" label="No. de Cuenta" variant="standard" onInput={validarSoloNumeros}
                                        error={Boolean(errors.nocuenta)}
                                        onBlur={handleBlur}
                                        helperText={errors.nocuenta}
                                    />
                                </FormControl>
                            </Stack>
                        </Grid>

                    </Box>
                </Stack>
                <Box>
                    <Stack direction="row">
                        <Grid>
                            <Stack>
                                <h3>X. DEUDAS A CONSOLIDAR</h3>
                            </Stack>
                            <Box>
                                <TableContainer component={Paper}>
                                    <Table aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell style={{ width: 100 }} rowSpan={2} align="center">Institución Financiera</StyledTableCell>
                                                <TableCell colSpan={3} align="center"> Monto</TableCell>
                                                <StyledTableCell colSpan={2} align="center">Consolidación</StyledTableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center" sx={{ m: 1, width: 150 }}>Lempiras</TableCell>
                                                <TableCell align="center" sx={{ m: 1, width: 150 }}>Dólares</TableCell>
                                                <TableCell align="center" sx={{ m: 1, width: 150 }}>Total Lempiras</TableCell>
                                                <StyledTableCell align="center" sx={{ m: 1, width: 150 }}>Total</StyledTableCell>
                                                <StyledTableCell align="center" sx={{ m: 1, width: 150 }}>Parcial</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {[1, 2, 3, 4, 5].map((row) => (
                                                <>
                                                    <TableRow key={row}>
                                                        <StyledTableCell component="th" scope="row">
                                                            <Box sx={{ m: 1, width: 300 }}>
                                                                <Autocomplete
                                                                    id={`solicitanteBancoCuentaConsolidar${row}`}
                                                                    {...defaultPropsBancos}
                                                                    renderInput={(params) => (
                                                                        <TextField
                                                                            {...params}
                                                                            id={`solicitanteBancoCuentaConsolidar${row}`}
                                                                            label={`Nombre del Banco ${row}`}
                                                                            variant="standard"
                                                                            error={Boolean(errors[`solicitanteBancoCuentaConsolidar${row}`])}
                                                                            // onBlur={handleBlur}
                                                                            helperText={errors[`solicitanteBancoCuentaConsolidar${row}`]}
                                                                        />
                                                                    )}
                                                                />
                                                            </Box>
                                                        </StyledTableCell>
                                                        <TableCell align="right">
                                                            <FormControl sx={{ m: 1, width: 100 }}>
                                                                <TextField
                                                                    id={`lempirasconsolidar${row}`}
                                                                    variant="standard"
                                                                    onInput={(event) => {
                                                                        validarSoloNumeros(event);//validarSoloNumerosComa(event);
                                                                    }}
                                                                    onBlur={(event) => {
                                                                        handleLempirasBlur(event, row);
                                                                        handleBlur(event);
                                                                        calcularTotales();
                                                                    }}
                                                                    error={Boolean(errors[`lempirasconsolidar${row}`])}
                                                                    helperText={errors[`lempirasconsolidar${row}`]}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <FormControl sx={{ m: 1, width: 100 }}>
                                                                <TextField
                                                                    id={`dolaresconsolidar${row}`}
                                                                    variant="standard"
                                                                    onInput={(event) => {
                                                                        validarSoloNumeros(event);//validarSoloNumerosComa(event);
                                                                    }}
                                                                    onBlur={(event) => {
                                                                        handleLempirasBlur(event, row);
                                                                        handleBlur(event);
                                                                        calcularTotales();
                                                                    }}
                                                                    error={Boolean(errors[`dolaresconsolidar${row}`])}
                                                                    helperText={errors[`dolaresconsolidar${row}`]}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <FormControl sx={{ m: 1, width: 100 }}>
                                                                <TextField
                                                                    id={`total-lempiras-consolidar-${row}`}
                                                                    variant="standard"
                                                                    InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                                />
                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <FormControl sx={{ m: 1, width: 100 }}>
                                                                <TextField
                                                                    id={`consolidaciontotal${row}`}
                                                                    variant="standard"
                                                                    InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                                />
                                                            </FormControl>
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <FormControl sx={{ m: 1, width: 100 }}>
                                                                <TextField
                                                                    id={`consolidacionparcial${row}`}
                                                                    variant="standard"
                                                                    onInput={(event) => {
                                                                        validarSoloNumeros(event);//validarSoloNumerosComa(event);
                                                                        setConsolidacionParcial(parseInt(event.target.value) || 0);
                                                                    }}
                                                                    onBlur={(event) => {
                                                                        handleBlur(event);
                                                                        calcularTotales();
                                                                    }}
                                                                    error={Boolean(errors[`consolidacionparcial${row}`])}
                                                                    helperText={errors[`consolidacionparcial${row}`]}
                                                                    InputProps={{ startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                                />
                                                            </FormControl>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                            <TableRow>
                                                <StyledTableCell component="th">
                                                    <Box sx={{ m: 1, width: 300 }} textAlign={"center"}>
                                                        <strong><label>TOTAL DEL PRÉSTAMO</label></strong>
                                                    </Box>
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`lempirasconsolidar`}
                                                            variant="standard"
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`dolaresconsolidar`}
                                                            variant="standard"
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`total-lempiras-consolidar`}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidaciontotal`}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidacionparcial`}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                            {/*<TableRow>
                                                <StyledTableCell component="th">
                                                    <Box sx={{ m: 1, width: 300 }} textAlign={"center"}>
                                                        <strong><label>MONTO A FAVOR DEL SOLICITANTE</label></strong>
                                                    </Box>
                                                </StyledTableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`lempirasconsolidar`}
                                                            variant="standard"
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`dolaresconsolidar`}
                                                            variant="standard"
                                                            InputProps={{
                                                                readOnly: true, startAdornment: <InputAdornment position="start">$.</InputAdornment>,
                                                            }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`total-lempiras-consolidar`}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidaciontotal`}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FormControl sx={{ m: 1, width: 100 }}>
                                                        <TextField
                                                            id={`consolidacionparcial`}
                                                            variant="standard"
                                                            InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>*/}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                    </Stack>
                </Box>
                <Box marginTop={5}>
                    {<h3>XI. VOUCHERS DE PAGO EN FORMATO PDF</h3>}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        onDragOver={handleDragOver}
                        onDrop={handleDrop}
                    >
                        <Box
                            style={{
                                padding: '50px',
                                width: '700px',
                                textAlign: 'center',
                                borderColor: selectedFile ? 'green' : '#a0a0a0',
                                borderRadius: 5,
                                borderWidth: 5,
                                borderStyle: 'dashed',
                            }}
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                            <br />
                            <Button
                                variant="contained"
                                onClick={handleClick}
                                style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                            >
                                Seleccionar Archivo PDF
                            </Button>
                            <input
                                id="fileInput"
                                type="file"
                                accept=".pdf"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            {!selectedFile && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                            {selectedFile && <p>Archivo seleccionado: {selectedFile.name}</p>}
                        </Box>
                    </Box>
                    {/*<h3>XI. DETALLE DE SALARIO Y DEDUCCIONES DEL SOLICITANTE </h3>*/}
                    {/*<Stack direction="row">
                <Grid>
                <Box>
            <TableContainer component={Paper}>
                <Table aria-label="customized table">
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell colSpan={2}>
                            <h3>Para uso exclusivo de Recursos Humanos</h3>
                            </StyledTableCell>
                        </StyledTableRow>
                        <TableRow key="rrhh">
                            <TableCell component="th">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="rrhhSalarioMensual"
                                        label="Salario Nominal Mensual"
                                        variant="standard"
                                        onInput={(event) => {
                                            validarSoloNumeros(event);
                                            setSalarioMensual(parseInt(event.target.value) || 0);
                                        }}
                                        onBlur={handleBlurSalario}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                        }}
                                        error={Boolean(errors["rrhhSalarioMensual"])} 
                                        helperText={errors["rrhhSalarioMensual"]}
                                    />
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <CustomDatePickerIngreso label="Fecha Ingreso" id="rrhhingreso" />
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="ihss"
                                        label="I.H.S.S."
                                        variant="standard"
                                        onInput={(event) => {
                                            validarSoloNumeros(event);
                                            setIhss(parseInt(event.target.value) || 0);
                                        }}
                                        onBlur={handleBlurSalario}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                        }}
                                    />
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="I.S.R"
                                        label="I.S.R."
                                        variant="standard"
                                        onInput={(event) => {
                                            validarSoloNumeros(event);
                                            setIsr(parseInt(event.target.value) || 0);
                                        }}
                                        onBlur={handleBlurSalario}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                        }}
                                    />
                                </FormControl>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="prestamo-con-injupemp"
                                        label="Préstamo personal con INJUPEMP"
                                        variant="standard"
                                        onInput={(event) => {
                                            validarSoloNumeros(event);
                                            setPrestamoInjupemp(parseInt(event.target.value) || 0);
                                        }}
                                        onBlur={handleBlurSalario}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                        }}
                                    />
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="pensionjubilacion"
                                        label="Pensión y Jubilación"
                                        variant="standard"
                                        onInput={(event) => {
                                            validarSoloNumeros(event);
                                            setPensionJubilacion(parseInt(event.target.value) || 0);
                                        }}
                                        onBlur={handleBlurSalario}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                        }}
                                    />
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        
                        <TableRow>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField 
                                id="embargos" 
                                label="Embargos" 
                                variant="standard"
                                onInput={(event) => {
                                            validarSoloNumeros(event);
                                            setEmbargos(parseInt(event.target.value) || 0);
                                        }}
                                        onBlur={handleBlurSalario}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">L.</InputAdornment>),
                                        }}
                                />
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle1" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos1(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}
                                />
                                </FormControl>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle2" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos2(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}/>
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle3" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos3(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}/>
                                </FormControl>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle4" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos4(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}/>
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle5" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos5(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}/>
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        
                        <TableRow>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle6" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos6(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}/>
                                </FormControl>
                            </TableCell>
                            <TableCell align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                <TextField id="otrodetalle7" label="Otro (detalle):" variant="standard"
                                onInput={(event) => {
                                    validarSoloNumeros(event);
                                    setOtrosIngresos7(parseInt(event.target.value) || 0);
                                }}
                                onBlur={handleBlurSalario}/>
                                </FormControl>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={2} align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="totaldeducciones"
                                        label="TOTAL DEDUCCIONES:"
                                        variant="standard"
                                        value={totalDeducciones}
                                        fullWidth={true}
                                        InputProps={{
                                            readOnly: true,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                L.
                                                </InputAdornment>
                                            ),
                                          }}
                                    />
                                </FormControl>
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={2} align="right">
                                <FormControl sx={{ m: 1, width: 550 }}>
                                    <TextField
                                        id="cantidadneta"
                                        label="CANTIDAD NETA QUE PERCIBE AL MES:"
                                        variant="standard"
                                        value={cantidadNeta}
                                        fullWidth={true}
                                        InputProps={{
                                            readOnly: true,
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                L.
                                                </InputAdornment>
                                            ),
                                          }}
                                    />
                                </FormControl>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
                </Grid>
                                        </Stack>*/}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '20vh', // Establece la altura de la caja para ocupar toda la pantalla verticalmente
                    }}
                >
                    <Grid item>
                        <Button
                            onClick={validateErrors}
                            endIcon={<SendIcon />}
                            variant="contained"
                            color="success"
                            size="large"
                        >
                            <span>Enviar Solicitud</span>
                        </Button>
                        <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                            open={open}
                        //onClick={handleClose}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </Grid>
                    <Dialog open={openDialog} onClose={handleCloseDialog}>
                        <DialogTitle>{"Enviado"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description" align='justify'>
                                Los datos fueron enviados con éxito.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialog} variant='contained' startIcon={< CheckCircleOutlineIcon />} color="success">
                                Aceptar
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog open={openDialogErrores} onClose={handleCloseDialogErrores}>
                        <DialogTitle>
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <ReportProblemIcon style={{ marginRight: '5px', color: 'var(--color-brand-secondary)' }} />
                                Error de Validación
                                <ReportProblemIcon style={{ marginLeft: '5px', color: 'var(--color-brand-secondary)' }} />
                            </span>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Hay errores en el formulario. Por favor, corríjalos antes de enviar.
                            </DialogContentText>
                            <Divider></Divider>
                            <ul>
                                {Object.entries(errors).map(([fieldName, errorMessage]) => (
                                    <li key={fieldName}>{errorMessage}</li>
                                ))}
                            </ul>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDialogErrores} variant='contained' startIcon={< CheckCircleOutlineIcon />} color="success">
                                Aceptar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Container>
        </div>

    </>)
}

const listadepartamentos = [
    { title: 'Atlantida', },
    { title: 'Colón', },
    { title: 'Comayagua', },
    { title: 'Copán', },
    { title: 'Cortés', },
    { title: 'Choluteca', },
    { title: 'El Paraíso', },
    { title: 'Francisco Morazán', },
    { title: 'Gracias A Dios', },
    { title: 'Intibucá', },
    { title: 'Islas De La Bahía', },
    { title: 'La Paz', },
    { title: 'Lempira', },
    { title: 'Ocotepeque', },
    { title: 'Olancho', },
    { title: 'Santa Bárbara', },
    { title: 'Valle', },
    { title: 'Yoro', },
];

const listacivil = [
    { title: 'Soltero', },
    { title: 'Casado', },
    { title: 'Viudo', },
    { title: 'Divorciado', },
    { title: 'Unión Libre', },
];

const listabancos = [
    { title: 'Banco Atlántida S.A.', },
    { title: 'Banco de Occidente S.A.', },
    { title: 'Banco de Los Trabajadores', },
    { title: 'Banco Financiera Centroamericana S.A. (FICENSA)', },
    { title: 'Banco Hondureño del Café S.A. (BANHCAFE)', },
    { title: 'Banco del País S.A. (BANPAIS)', },
    { title: 'Banco Financiera Comercial Hondureña S.A. (FICOHSA)', },
    { title: 'Banco Lafise Honduras  S.A.', },
    { title: 'Banco Davivienda Honduras S.A.', },
    { title: 'Banco Promérica S.A.', },
    { title: 'Banco de Desarrollo Rural Honduras S.A.', },
    { title: 'Banco Azteca de Honduras S.A.', },
    { title: 'Banco Popular S.A.', },
    { title: 'Banco de América Central Honduras S.A. (BAC) | Honduras', },
    { title: 'Banco de Honduras (Citi Honduras)', },
    { title: 'Banco Nacional de Desarrollo Agrícola (BANADESA)', },
    { title: 'Banco Hondureño para la Producción y la Vivienda (BANHPROVI)', },
];

export default ParticipanteSolicitudes;
